PJQ.views.projects.ProjectMessagingDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            zeroRecords: "No data to display"
        },
        subTemplates: {
            commentsTooltip: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'tooltip-comments'),
            addCommentTooltip: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'tooltip-add-comment'),
        },
        isHideSearch: true,
        dom: '<"top"p<"clear">>rt<"bottom"p<"clear">>',
        enableColumnResize: false
    },
    onColumnResizeEnd: function (c, columns) {
        let totalWidth = 0,
            colWidths = {};
        _.each(columns, function (col) {
            let colWidth = parseInt(col.width.replace('px', ''));
            totalWidth += colWidth;
            colWidths[col.idx] = colWidth;
        });

        let colPercents = {},
            totalPercent = 0;
        _.each(colWidths, function (col, idx) {
            let percent = (col / totalWidth) * 100;
            if (percent < 2) {
                percent = 2;
            } else {
                percent = Math.floor(percent);
            }
            totalPercent += percent;
            colPercents[idx] = percent;
        });

        let newColumns = [];
        _.each(this.options.settings.columns, function (col, idx) {
            let data,
                colTp = typeof col;
            if (colTp === 'string') {
                data = col;
            } else if (colTp === 'object' && typeof colTp.data === 'string') {
                data = colTp.data;
            } else {
                data = "";
            }
            newColumns.push({
                data: data,
                width: colPercents[idx].toString() + '%'
            });
        })
        this.options.settings.columns = newColumns;
    },
    beforeDataTableRender: function () {
        this.options.scrollRows = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DATA_TABLE_FIXED_HEADER);

        this.options.projectStatusList = PJQ.app.session.project.getProjectStatusList();
        this.options.childDataTables = [];

        this.options.contextMenuOptions = {
            actions: this.getContextMenuItems(),
            isHideNoActions: true
        };

        if (this.options.settings) {
            // enable paging for grids that have a setting for it / are not subgrids
            if (this.options.settings.rowsPerPage !== 0 && this.options.view.indexOf('-') === -1)
                this.options.pageLength = this.options.settings.rowsPerPage;
            else
                this.options.pageLength = 2147483646;

            this.setCustomOrder();

            let fixedColumnsLeft = 0;
            switch (this.options.settings.view) {
                case PJQ.constants.projectMessaging.views.GROUPCONT:
                case PJQ.constants.projectMessaging.views.GROUPCONT_CONT:
                case PJQ.constants.projectMessaging.views.GROUPCOMP:
                case PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT:
                case PJQ.constants.projectMessaging.views.MSGCONT:
                case PJQ.constants.projectMessaging.views.MSGCONT_CONT:
                case PJQ.constants.projectMessaging.views.RSPCONT:
                case PJQ.constants.projectMessaging.views.RSPCONT_CONT:
                case PJQ.constants.projectMessaging.views.BIDPKGS_CONT:
                    fixedColumnsLeft = 1;
                    break;
                case PJQ.constants.projectMessaging.views.GROUPCOMP_COMP:
                case PJQ.constants.projectMessaging.views.CONT:
                case PJQ.constants.projectMessaging.views.COMP:
                case PJQ.constants.projectMessaging.views.COMP_CONT:
                    fixedColumnsLeft = 2;
                    break;
            }
            if (fixedColumnsLeft > 0) {
                this.options.colReorder = {
                    fixedColumnsLeft: fixedColumnsLeft,
                    realtime: false
                };
            }
        }

        this.options.createdRow = _.bind(this.createdRow, this);

        if (typeof this.options.beforeDataTableRender === 'function') {
            this.options.beforeDataTableRender();
        }
    },
    setCustomOrder: function () {
        if (!this.options.settings)
            return;

        if (this.options.settings.orderBy !== 'sortOrder') {
            if (_.size(this.options.settings.columns) === 0) {
                this.options.settings.orderBy = this.options.settings.columnsDefault[0];
            } else if (this.options.settings.columns.indexOf(this.options.settings.orderBy) === -1) {
                this.options.settings.orderBy = this.options.settings.columns[0];
            }
        }
        _.each(this.getColumns(false, this.options.view), _.bind(function (column, index) {
            if (column.columnData === this.options.settings.orderBy) {
                this.options.order = [[index, this.options.settings.orderAscending ? 'asc' : 'desc']];
            }
        }, this));

        if (this.options.settings.view !== PJQ.constants.projectMessaging.views.GROUPCONT &&
            this.options.settings.view !== PJQ.constants.projectMessaging.views.GROUPCOMP &&
            this.options.settings.view !== PJQ.constants.projectMessaging.views.BIDPKGS &&
            this.options.settings.view !== PJQ.constants.projectMessaging.views.MSGCONT &&
            this.options.settings.view !== PJQ.constants.projectMessaging.views.RSPCONT) {
            _.each(this.getColumns(false, this.options.view), _.bind(function (column, index) {
                if (column.columnData === 'companyName' && this.options.settings.orderBy !== 'companyName') {
                    this.options.order.push([index, 'asc']);
                }
            }, this));
            _.each(this.getColumns(false, this.options.view), _.bind(function (column, index) {
                if (column.columnData === 'contactName' && this.options.settings.orderBy !== 'contactName') {
                    this.options.order.push([index, 'asc']);
                }
            }, this));
            if (this.dataTable) {
                this.dataTable.order(this.options.order).draw();
            }
        }
    },
    columnOrderChanged: function (columns) {
        if (this.options.userSettings != null) {
            /* #311 - error when drag-drop sorting columns.
            let settings = this.options.userSettings.get('settings');
            for (let i = 0; i < _.size(settings); i++) {
                if (settings[i].view === this.options.view) {
                    settings[i].columns = columns;
                }
            }
            this.options.userSettings.set('settings', settings);

             */
            this.options.userSettings.save();
        }
    },
    orderByChanged: function (columns) {
        this.setCustomOrder();
        if (this.options.userSettings != null) {
            let settings = this.options.userSettings.get('settings');
            for (let i = 0; i < _.size(settings); i++) {
                if (settings[i].view === this.options.settings.view) {
                    settings[i].orderBy = this.options.settings.orderBy;
                    settings[i].orderAscending = this.options.settings.orderAscending;
                }
            }
            this.options.userSettings.set('settings', settings);
            this.options.userSettings.save();
        }
    },
    afterDataTableRender: function () {
        this.afterDataTableRenderChild();
    },
    afterDataTableRenderChild: function () {
    },
    getRowChildTable: function (childOpts) {
    },
    getRowChildData: function (row) {
    },
    setRowStyle: function (row, status, isBlacklisted) {
    },
    getContextMenuItems: function () {

    },
    statusChanged: function (statuses) {
    },
    getCustomFieldColumn: function (customField, isCompany) {
        return {
            "columnData": (isCompany ? 'companyCustomField' : 'contactCustomField') + '_' + customField.get('id'),
            "title": customField.get('fieldName'),
            "render": function (data, type, row) {
                let rowField;
                if (isCompany) {
                    rowField = row.getCompanyCustomField(customField.get('id'));
                } else {
                    rowField = row.getContactCustomField(customField.get('id'));
                }

                let fieldValue = null;
                if (rowField != null) {
                    fieldValue = rowField.value;
                }
                switch (customField.get('fieldType')) {
                    case PJQ.constants.customFields.fieldTypes.TEXT:
                        if (fieldValue && type !== 'sort' && type !== 'type') {
                            if (PJQ.helpers.urlHelpers.isURL(fieldValue))
                                fieldValue = '<a target="_blank" href="' + fieldValue + '">' + fieldValue + '</a>';
                        }
                        break
                    case PJQ.constants.customFields.fieldTypes.DATE:
                        if (fieldValue) {
                            if (type !== 'sort' && type !== 'type')
                                fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE);
                        }
                        break;
                    case PJQ.constants.customFields.fieldTypes.DATETIME:
                        if (fieldValue) {
                            if (type !== 'sort' && type !== 'type')
                                fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }
                        break;
                    case PJQ.constants.customFields.fieldTypes.BOOL:
                        if (fieldValue != null)
                            fieldValue = fieldValue ? 'Yes' : 'No';
                        else
                            fieldValue = '';
                        break;
                    case PJQ.constants.customFields.fieldTypes.CHOICE:
                        if (fieldValue) {
                            let choices = [];

                            // convert single choice value into array so that the logic below can work for both types.
                            if (typeof fieldValue === 'number')
                                fieldValue = [fieldValue];

                            _.each(customField.choices.models, _.bind(function (choice) {
                                if (_.find(fieldValue, function (value) {
                                    return value === choice.get('id');
                                }))
                                    choices.push(choice.get('choiceName'));
                            }, this));

                            fieldValue = choices.join((', '));
                        }
                        break;
                    case PJQ.constants.customFields.fieldTypes.MONEY:
                        if (type === 'sort' || type === 'type') {
                            if (fieldValue && fieldValue !== '$')
                                fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                            else
                                fieldValue = 0;

                        } else
                            fieldValue = PJQ.helpers.formatHelpers.formatCurrency(fieldValue);
                        break;
                    case PJQ.constants.customFields.fieldTypes.PHONE:
                        if (type !== 'sort' && type !== 'type') {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (fieldValue ? PJQ.helpers.formatHelpers.formatPhoneNumber(fieldValue) : 'N/A'),
                                phoneWrapped = (fieldValue ? PJQ.helpers.formatHelpers.formatPhoneNumber(fieldValue, true) : 'N/A');

                            if (fieldValue !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (fieldValue ? '' : 'text-muted') + '">' + phoneWrapped + '</div>';
                            html += '</div>';

                            fieldValue = html;
                        }
                        break;
                }
                return fieldValue;
            },
            "customFieldId": customField.get('id')
        };
    },
    gradeContactCompany: function (sender) {
        let $target = $(sender.currentTarget),
            contactCompanyId = $target.data('contactCompanyId'),
            tr = $target.closest('tr'),
            parentTR = $target.closest('tr').parent().closest('tr').prev(),
            row = this.getRow(tr);

        new PJQ.views.projects.GradeProjectContactModal({
            contactCompanyId: contactCompanyId,
            row: row,
            onGrade: _.bind(function (grade) {
                let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: PJQ.app.session.project.id
                    },
                    {
                        endpoint: 'participants',
                        value: row.data().get('contactCompanyId')

                    },
                    {
                        endpoint: 'grade',
                        value: row.data().get('grade')

                    }
                ]);
                new PJQ.ajax.Request({
                    endpoint: endpoint
                }).post().done(_.bind(function (data) {
                    row.data().set('gradeAverage', data);
                    row.invalidate().draw();

                    if (this.options.view === PJQ.constants.projectMessaging.views.COMP || this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP) {
                        // update child table for this company
                        _.each(this.options.childDataTables, _.bind(function (childDT) {
                            if (typeof childDT.statusChanged === 'function') {
                                if (row.data().get('contactCompanyId') !== childDT.$el.data('id'))
                                    return;

                                _.each(childDT.dataTable.data(), _.bind(function (item) {
                                    item.set('gradeAverage', data);
                                    item.set('grade', row.data().get('grade'));
                                }, this));

                                childDT.dataTable.rows().invalidate().draw();
                            }
                        }, this));

                    } else if (this.options.view === PJQ.constants.projectMessaging.views.COMP_CONT || this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT) {
                        // update all other rows in this table for the same company
                        _.each(this.dataTable.data(), _.bind(function (item) {
                            item.set('gradeAverage', data);
                            item.set('grade', row.data().get('grade'));
                        }, this));
                        this.dataTable.rows().invalidate().draw();

                        // update parent table / company row
                        let rowParent = this.options.parentDataTable.getRow(parentTR);
                        rowParent.data().set('gradeAverage', data);
                        rowParent.data().set('grade', row.data().get('grade'));
                        rowParent.invalidate().draw();
                    }

                    PJQ.notifications.notify.successNotify({
                        message: 'Grade recorded successfully'
                    });
                }, this)).fail(function () {
                    PJQ.notifications.notify.errorNotify({
                        message: 'Unable to record Grade.  Please contact customer service.'
                    });
                });
            }, this)
        });
    },
    childRowToggle: function (sender) {
        let $target = $(sender.currentTarget),
            id = $target.data('id'),
            tr = $target.closest('tr'),
            row = this.getRow(tr);
        if (row.child.isShown()) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass('shown');
            $target.removeClass('fa-minus-circle').addClass('fa-plus-circle');
        } else {
            $target.removeClass('fa-plus-circle').addClass('fa-minus-circle');
            let childClass = 'subgrid-' + id.toString(),
                $childTable = $('<div data-id="' + id + '" />', {
                    class: childClass + ' p-2'
                });
            row.child($childTable).show();

            let childData = this.getRowChildData(row);
            if (childData != null) {
                childData.fetch({
                    success: _.bind(function () {
                        if (this.options.view === PJQ.constants.projectMessaging.views.GROUPCONT) {
                            let selectedContactGroups = [], groupId = parseInt(childData.options.groupIdList);
                            _.each(childData.models, _.bind(function (contact) {
                                _.each(this.options.projectMessagingView.options.selectedContactGroups, _.bind(function (contactGroup) {
                                    if (contactGroup.contactId === contact.get('contactId'))
                                        selectedContactGroups.push({
                                            contactId: contact.get('contactId'),
                                            groupId: groupId
                                        });
                                }, this));
                            }, this));
                            this.options.projectMessagingView.addSelectedContactGroups(selectedContactGroups);
                        }

                        if (this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP) {
                            let selectedContactGroups = [], groupId = parseInt(childData.options.groupIdList),
                                isEnableDeclined = this.options.projectMessagingView.isEnableDeclined();

                            _.each(childData.models, _.bind(function (company) {

                                let selectedContacts = company.attributes.selectableContacts;
                                if (isEnableDeclined)
                                    $.merge(selectedContacts, company.attributes.declinedContacts);

                                _.each(selectedContacts, _.bind(function (contact) {
                                    _.each(this.options.projectMessagingView.options.selectedContactGroups, _.bind(function (contactGroup) {

                                        // iterate through selectable contacts and add em if their ids match the list
                                        if (contactGroup.contactId === contact)
                                            selectedContactGroups.push({contactId: contact, groupId: groupId});
                                    }, this));

                                }, this));

                            }, this));

                            this.options.projectMessagingView.addSelectedContactGroups(selectedContactGroups);
                        }

                        let childTable = this.getRowChildTable({
                            el: $childTable,
                            data: childData.models,
                            parentDataTable: this,
                            parentId: id,
                            projectMessagingView: this.options.projectMessagingView
                        });
                        this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                            return childDt.options.parentId !== id;
                        }, this));
                        this.options.childDataTables.push(childTable);
                        tr.addClass('shown');
                    }, this)
                });
            }
        }
    },
    childRowToggleAll: function (sender) {
        let $target = $(sender.currentTarget);

        this.dataTable.rows().eq(0).each(_.bind(function (index) {
            let row = this.dataTable.row(index), id = row.data().get('groupId');

            if ($target.hasClass('fa-plus-circle') && !row.child.isShown()) {
                let childClass = 'subgrid-' + id.toString(),
                    $childTable = $('<div data-id="' + id + '" />', {
                        class: childClass
                    });
                row.child($childTable).show();

                let childData = this.getRowChildData(row);
                if (childData != null) {
                    childData.fetch({
                        success: _.bind(function () {
                            let childTable = this.getRowChildTable({
                                el: $childTable,
                                data: childData.models,
                                parentDataTable: this,
                                parentId: id,
                                projectMessagingView: this.options.projectMessagingView
                            });
                            this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                                return childDt.options.parentId !== id;
                            }, this));
                            this.options.childDataTables.push(childTable);
                            $(row.node()).addClass('shown');
                        }, this)
                    });
                }
            } else if ($target.hasClass('fa-minus-circle') && row.child.isShown()) {
                row.child.hide();
                $(row.node()).removeClass('shown');
            }

        }, this));

        if ($target.hasClass('fa-plus-circle'))
            $target.removeClass('fa-plus-circle').addClass('fa-minus-circle');
        else
            $target.removeClass('fa-minus-circle').addClass('fa-plus-circle');
    },
    onStatusChanged: function (e) {
        let $target = $(e.currentTarget),
            status = $target.val().toUpperCase(),
            row = this.getRow($target.closest('tr')),
            TR = $target.closest('tr'),
            parentTR = $target.closest('tr').parent().closest('tr').prev(),
            data = row.data(), callback = _.bind(function () {
                data.updateStatus(status, _.bind(function (statuses) {

                    data.set('status', status);

                    if (this.options.parentDataTable != null) {

                        if (this.options.view !== PJQ.constants.projectMessaging.views.CONTGROUP ||
                            (this.options.parentDataTable.options.view !== PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT &&
                                this.options.parentDataTable.options.view !== PJQ.constants.projectMessaging.views.GROUPCONT_CONT) ||
                            parseInt(this.options.parentDataTable.dataTable.rows(0).row().data().collection.options.groupIdList) === row.data().get('groupId')) {

                            this.options.parentDataTable.statusChanged(statuses, parentTR, this.options.view);
                        }
                    }

                    _.each(this.options.childDataTables, _.bind(function (childDT) {
                        if (typeof childDT.statusChanged === 'function') {
                            let data = row.data();
                            if ((data.collection.options.view === PJQ.constants.projectMessaging.views.COMP) && data.get('contactCompanyId') !== childDT.$el.data('id'))
                                return;

                            if ((data.collection.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT ||
                                    data.collection.options.view === PJQ.constants.projectMessaging.views.GROUPCONT_CONT ||
                                    data.collection.options.view === PJQ.constants.projectMessaging.views.COMP_CONT ||
                                    data.collection.options.view === PJQ.constants.projectMessaging.views.CONT ||
                                    data.collection.options.view === PJQ.constants.projectMessaging.views.MSGCONT_CONT ||
                                    data.collection.options.view === PJQ.constants.projectMessaging.views.RSPCONT_CONT ||
                                    data.collection.options.view === PJQ.constants.projectMessaging.views.BIDPKGS_CONT)
                                && data.get('contactId') !== childDT.$el.data('id'))
                                return;

                            childDT.statusChanged(statuses, null, this.options.view);
                        }
                    }, this));

                    this.setRowStyle(TR, data.attributes.status, data.attributes.isBlacklisted || data.attributes.isCompanyBlacklisted);

                    PJQ.notifications.notify.successNotify({
                        message: 'Status updated'
                    });
                }, this));
            }, this);

        let groupListArray = data.get('groupListDisplay') != null ? data.get('groupListDisplay').split(',') : [];
        if (groupListArray.length > 1 && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.RSVP_DISABLE_PER_GROUP) && this.options.view !== PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT && this.options.view !== PJQ.constants.projectMessaging.views.GROUPCONT_CONT && this.options.view !== PJQ.constants.projectMessaging.views.GROUPCOMP_COMP) {
            new PJQ.views.modals.YesNo({
                header: "Confirm Status Change",
                body: "Are you sure you want to change the status for all Trades for this Participant?",
                onYes: _.bind(function () {
                    callback();
                }, this),
                onNo: _.bind(function () {
                    $target.val(data.get('status'));
                }, this)
            });
        } else {
            callback();
        }
    },
    mouseoverComments: function (e) {
        let $target = $(e.currentTarget),
            row = this.getRow($target.closest('tr')),
            participant = row.data(),
            isCompanyComments = $target.hasClass('comment-company');
        if (_.size(isCompanyComments ? participant.get('lastCompanyComment') : participant.get('lastContactComment')) > 0) {
            this.commentHoverContactId = isCompanyComments ? null : participant.id;
            this.commentHoverContactCompanyId = isCompanyComments ? participant.id : null;
            let fnShowComments = _.bind(function (comments) {
                let tooltip = new PJQ.Tooltip($target, {
                    template: this.options.subTemplates.commentsTooltip,
                    container: this.$el,
                    trigger: 'hover',
                    renderData: function () {
                        return {
                            comments
                        };
                    }
                });
                tooltip.show();
            }, this);
            if (!isCompanyComments && participant.comments && participant.comments.isFetched) {
                fnShowComments(participant.comments);
            } else if (isCompanyComments && participant.companyComments && participant.companyComments.isFetched) {
                fnShowComments(participant.companyComments);
            } else {
                setTimeout(_.bind(function () {
                    if ((isCompanyComments && this.commentHoverContactCompanyId === participant.id)
                        || !isCompanyComments && this.commentHoverContactId === participant.id) {
                        let comments = new PJQ.collections.projectParticipants.ProjectParticipantComments(null, {
                            participant: participant,
                            project: PJQ.app.session.project,
                            isCompanyComments: isCompanyComments
                        });
                        comments.fetch({
                            success: _.bind(function () {
                                if (isCompanyComments) {
                                    participant.companyComments = comments;
                                } else {
                                    participant.comments = comments;
                                }
                                fnShowComments(comments);
                            }, this)
                        });
                    }
                }, this), 1000);
            }
        }
    },
    mouseleaveComments: function () {
        this.commentHoverContactId = null;
        this.commentHoverContactCompanyId = null;
    },
    addComment: function (e) {
        let $target = $(e.currentTarget),
            row = this.getRow($target.closest('tr')),
            participant = row.data(),
            isCompanyComments = $target.hasClass('btn-add-comment-company'),
            contextId = isCompanyComments ? participant.attributes.contactCompanyId : participant.attributes.contactId,
            tooltip = new PJQ.Tooltip($target, {
                template: this.options.subTemplates.addCommentTooltip,
                container: this.$el,
                trigger: 'click',
                title: '',
                onShow: _.bind(function () {
                    setTimeout(_.bind(function () {
                        this.$el.find('.comment-text-tooltip').focus();
                    }, this), 300);
                }, this),
                afterRender: _.bind(function (tp) {
                    this.$el.off('keypress', '.comment-text-tooltip[data-contact-id="'+contextId+'"]');
                    this.$el.on('keypress', '.comment-text-tooltip[data-contact-id="'+contextId+'"]', function (e) {
                        if (e.which === 13) {
                            $(this).siblings('.btn-add-comment-tooltip[data-contact-id="'+contextId+'"]').trigger('click');
                            e.preventDefault();
                        }
                    });

                    this.$el.off('click', '.btn-add-comment-tooltip[data-contact-id="'+contextId+'"]');
                    this.$el.on('click', '.btn-add-comment-tooltip[data-contact-id="'+contextId+'"]', _.bind(function (e) {
                        let $comment = $(e.currentTarget).parent().find('.comment-text-tooltip[data-contact-id="'+contextId+'"]'),
                            commentText = $comment.val();
                        if (_.size(commentText) > 0) {
                            let comment = new PJQ.models.projectParticipants.ProjectContactComment({
                                comment: commentText
                            }, {
                                project: PJQ.app.session.project,
                                contactId: contextId,
                                isCompanyComments: isCompanyComments
                            });
                            comment.save(null, {
                                success: _.bind(function () {
                                    tp.remove();

                                    let parentTR = $target.closest('tr').parent().closest('tr').prev(),
                                        rowParent = this.options.parentDataTable != null ? this.options.parentDataTable.getRow(parentTR) : null;
                                    this.onComment(row, rowParent, comment, isCompanyComments);
                                }, this)
                            });
                        }
                    }, this));
                }, this),
                renderData: function () {
                    return {
                        participant : participant,
                        contactId: contextId
                    };
                }
            });
        tooltip.show();
    },
    manageComments: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr')),
            parentTR = $(e.currentTarget).closest('tr').parent().closest('tr').prev(),
            participant = row.data(),
            isCompanyComments = $(e.currentTarget).hasClass('btn-comment-company') || $(e.currentTarget).hasClass('btn-comment-contact-company'),
            comments = new PJQ.collections.projectParticipants.ProjectParticipantComments(null, {
                participant: participant,
                project: PJQ.app.session.project,
                isCompanyComments: isCompanyComments
            });
        comments.fetch({
            success: _.bind(function () {
                new PJQ.views.projects.ProjectParticipantCommentModal({
                    participant: participant,
                    comments: comments.models,
                    project: PJQ.app.session.project,
                    isCompanyComments: isCompanyComments,
                    onComment: _.bind(function (comment) {
                        let rowParent = this.options.parentDataTable != null ? this.options.parentDataTable.getRow(parentTR) : null;
                        this.onComment(row, rowParent, comment, isCompanyComments);
                    }, this)
                });
            }, this)
        });
    },
    onComment: function (row, rowParent, comment, isCompanyComments) {
        row.data().set(isCompanyComments ? 'lastCompanyComment' : 'lastContactComment', {
            comment: comment.get('comment')
        });
        row.invalidate().draw(false);

        if (isCompanyComments) {
            // if this is a contact child view, update the company parent in case it has a company comment column also
            if (this.options.view === PJQ.constants.projectMessaging.views.COMP_CONT || this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT) {
                // update parent table / company row
                if (rowParent != null) {
                    rowParent.data().set('lastCompanyComment', {
                        comment: comment.get('comment')
                    });
                    rowParent.invalidate().draw(false);
                }
            } else if (this.options.view === PJQ.constants.projectMessaging.views.COMP || this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP) {
                // if this is a company view, update the contact child view in case it has a company comment column also
                _.each(this.options.childDataTables, _.bind(function (childDT) {
                    if (typeof childDT.statusChanged === 'function') {
                        if (row.data().get('contactCompanyId') !== childDT.$el.data('id'))
                            return;

                        _.each(childDT.dataTable.data(), _.bind(function (item) {
                            item.set('lastCompanyComment', {
                                comment: comment.get('comment')
                            });
                        }, this));
                        childDT.dataTable.rows().invalidate().draw(false);

                    }
                }, this));
            }
        }
    },
    getColumns: function () {
    },
    cleanup: function () {
        this.undelegateEvents();
        $(this.el).empty();
    },
    getIsRootView: function () {
        return (this.options.view.indexOf('-') === -1);
    },
    createdRow: function (row, data, dataIndex) {
    }
});

PJQ.views.projects.ProjectMessagingTradesDataTable = PJQ.views.projects.ProjectMessagingDataTable.extend({
    events: {
        'click i.trade-toggle-row': 'childRowToggle',
        'click i.trade-toggle-all-rows': 'childRowToggleAll',
        'change .trade-select-all-contacts': 'selectAll'
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [], includeColumns = ['groupName', 'groupStatus', 'groupCount'];

        this.totalParticipants = 0;
        this.selectColumnHeader = '';
        this.selectColumnWidth = '15px';
        _.each(this.options.data, _.bind(function (row) {
            this.totalParticipants += row.attributes.totalParticipants;
        }, this));
        if (this.totalParticipants < 1000) {
            this.selectColumnHeader = '<i class="fal fa-plus-circle trade-toggle-all-rows mr-1"></i>';
            this.selectColumnWidth = '2.8em';
        }
        this.selectColumnHeader += '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="trade-select-all-contacts" ' + (this.options.projectMessagingView && this.options.projectMessagingView.options.isTradesViewSelectAll ? 'checked="checked"' : '') + ' /><div class="state"><i class="icon fal fa-check"></i> <label class="wd-0">&nbsp;</label></div></div>';

        if (!includeAllColumns) {

            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            columns.push({
                "width": this.selectColumnWidth,
                "columnData": "groupMembers",
                "data": null,
                "title": this.selectColumnHeader,
                "className": "dt-center",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": function (data, type, row) {
                    return '<i class="fal fa-plus-circle trade-toggle-row" data-id="' + row.get('groupId') + '"></i>';
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            let cName,
                cNameTp = typeof columnName;
            if (cNameTp === 'string') {
                cName = columnName;
            } else if (cNameTp === 'object' && typeof cNameTp.data === 'string') {
                cName = cNameTp.data;
            } else {
                return;
            }
            switch (cName) {
                case 'groupName':
                    columns.push({
                        "columnData": "groupName",
                        "data": {
                            "_": "attributes.sortOrder",
                            "sort": "attributes.sortOrder",
                            "filter": "attributes.groupName",
                            "display": "attributes.groupName"
                        },
                        "title": "Trade",
                    });
                    break;
                case 'groupStatus':
                    columns.push({
                        "columnData": "groupStatus",
                        "render": function (data, type, row) {
                            if (type === 'sort' || type === 'type')
                                return '';

                            let innerHtml = '';
                            _.each(row.get('statuses'), _.bind(function (status) {
                                let statusPercent = (status.count / row.get('totalParticipants')) * 100,
                                    textColor = PJQ.helpers.colorHelpers.idealLinkColorForBackground(status.backgroundColor);
                                innerHtml += '<div class="progress-bar" role="progressbar" title="' + status.status + ' (' + status.count + ')" style="background-color: ' + status.backgroundColor + ';color: ' + textColor + ';width:' + statusPercent + '%">\n' +
                                    status.count +
                                    '</div>';
                            }, this));
                            let outerHtml = '<div class="progress">';
                            outerHtml += innerHtml + '</div>';
                            return outerHtml;
                        },
                        "title": "Status",
                        "orderable": false,
                        "width": "60%"
                    });
                    break;
                case 'groupCount':
                    columns.push({
                        "columnData": "groupCount",
                        "data": "attributes.totalParticipants",
                        "title": (this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP ? "Companies" : "Contacts"),
                        "width": "40px",
                        "render": function (data) {
                            return '<div class="text-align-center">' + data.toString() + '</div>';
                        }
                    });
                    break;
            }
        }, this));

        return columns;
    },
    getChildTableType: function () {
        if (this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP) {
            return PJQ.constants.projectMessaging.views.GROUPCOMP_COMP;
        } else if (this.options.view === PJQ.constants.projectMessaging.views.GROUPCONT) {
            return PJQ.constants.projectMessaging.views.GROUPCONT_CONT;
        }
    },
    getChildTableSettings: function () {
        return this.options.projectMessagingView.options.settings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {
        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.userSettings;
        childOpts.projectMessagingView = this.options.projectMessagingView;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP ? new PJQ.views.projects.ProjectMessagingCompanyDataTable(childOpts) : new PJQ.views.projects.ProjectMessagingContactDataTable(childOpts);
    },
    getRowChildData: function (row) {
        let searchFor = this.options.projectMessagingView.getSearchFor(),
            statusFilter = [...this.options.projectMessagingView.options.filter.status];

        if (this.options.projectMessagingView.options.filter.isDelivered)
            statusFilter.push('DELIVERED');

        if (this.options.projectMessagingView.options.filter.isOpened)
            statusFilter.push('OPENED');

        if (this.options.projectMessagingView.options.filter.isVisited)
            statusFilter.push('VISITED');

        if (this.options.projectMessagingView.options.filter.isDownloaded)
            statusFilter.push('DOWNLOADS');

        if (this.options.projectMessagingView.options.filter.isPrintOrder)
            statusFilter.push('ORDERS ONLY');

        if (this.options.projectMessagingView.options.filter.publicPrivate)
            statusFilter.push(this.options.projectMessagingView.options.filter.publicPrivate);

        _.each(this.options.projectMessagingView.options.filter.laborStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        _.each(this.options.projectMessagingView.options.filter.minorityStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        return new PJQ.collections.projectParticipants.ProjectParticipantsForView(null, {
            project: PJQ.app.session.project,
            view: this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP ? PJQ.constants.projectMessaging.views.COMP : PJQ.constants.projectMessaging.views.CONT,
            groupIdList: row.data().get('groupId').toString(),
            statusFilter: _.uniq(statusFilter).join(','),
            searchFor: searchFor,
            isPerGroup: true,
            withCustomFields: this.getChildTableSettings().hasCustomFields
        });
    },
    selectAll: function (e) {
        let loader = new PJQ.Loader($('.nav-body'));
        let isSelected = $(e.currentTarget).prop('checked');
        this.options.projectMessagingView.options.isTradesViewSelectAll = isSelected;
        this.options.projectMessagingView.options.selectedContacts = [];
        if (isSelected) {
            // get company/contact list for project, iterate through it and add any that aren't declined (unless enabledeclined is true)
            this.options.projectMessagingView.getViewData(this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP ? 'company' : 'contact', _.bind(function (data) {
                let enableDeclined = this.options.projectMessagingView.isEnableDeclined();
                _.each(data.models, _.bind(function (model) {

                    if (this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP) {
                        _.each(model.get('selectableContacts'), _.bind(function (id) {
                            this.options.projectMessagingView.options.selectedContacts.push(id);
                        }, this));

                        if ((enableDeclined) && _.size(model.get('declinedContacts')) > 0) {
                            _.each(model.get('declinedContacts'), _.bind(function (id) {
                                this.options.projectMessagingView.options.selectedContacts.push(id);
                            }, this));

                        }
                    } else {
                        let isDeclined = (this.options.projectStatusList[1].toString().split(',')[0].toLowerCase() === model.get('status').toString().toLowerCase());
                        if ((enableDeclined || !isDeclined) && !model.attributes.isBlacklisted && !model.attributes.isCompanyBlacklisted)
                            this.options.projectMessagingView.options.selectedContacts.push(model.id);
                    }

                }, this));

                this.options.projectMessagingView.options.selectedContacts = _.uniq(this.options.projectMessagingView.options.selectedContacts);
                this.options.projectMessagingView.renderContactStats();
                this.options.projectMessagingView.renderView();
                loader.remove();
            }, this), {isPerGroup: true});
        } else {
            // clear any visible checkboxes in sub-grids
            this.$('.select-company,.select-contact').prop('checked', false);
            loader.remove();
        }

        this.options.projectMessagingView.renderContactStats();
    }
});

PJQ.views.projects.ProjectMessagingBidPackagesDataTable = PJQ.views.projects.ProjectMessagingDataTable.extend({
    events: {
        'click i.trade-toggle-row': 'childRowToggle',
        'click i.trade-toggle-all-rows': 'childRowToggleAll',
        'change .trade-select-all-contacts': 'selectAll',
        'change select.bid-package-count': 'onBidPackageCountChanged',
        'blur .bid-package-notes': 'onBidPackageNotesChanged'
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [], includeColumns = ['name', 'bidPackageStatus', 'participantsCount'];

        this.totalParticipants = 0;
        this.selectColumnHeader = '';
        this.selectColumnWidth = '15px';
        _.each(this.options.data, _.bind(function (row) {
            this.totalParticipants += row.attributes.totalParticipants;
        }, this));
        if (this.totalParticipants < 1000) {
            this.selectColumnHeader = '<i class="fal fa-plus-circle trade-toggle-all-rows mr-1"></i>';
            this.selectColumnWidth = '2.8em';
        }
        this.selectColumnHeader += '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="trade-select-all-contacts" ' + (this.options.projectMessagingView && this.options.projectMessagingView.options.isTradesViewSelectAll ? 'checked="checked"' : '') + ' /><div class="state"><i class="icon fal fa-check"></i> <label class="wd-0">&nbsp;</label></div></div>';

        let enableCount = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_PACKAGES_COUNT);
        if (!includeAllColumns) {
            if (enableCount) {
                includeColumns = ['name', 'bidPackageCount', 'bidPackageStatus', 'participantsCount'];
            } else {
                includeColumns = this.options.settings.columnsDefault;
            }

            columns.push({
                "width": this.selectColumnWidth,
                "columnData": "groupMembers",
                "data": null,
                "title": this.selectColumnHeader,
                "className": "dt-center",
                "orderable": false,
                "width": "5%",
                "searchable": false,
                "defaultContent": '',
                "render": function (data, type, row) {
                    return '<i class="fal fa-plus-circle trade-toggle-row" data-id="' + row.get('groupId') + '"></i>';
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'name':
                    columns.push({
                        "columnData": "sortOrder",
                        "width": "30%",
                        "data": {
                            "_": "attributes.sortOrder",
                            "sort": "attributes.sortOrder",
                            "filter": "attributes.bidPackageName",
                            "display": "attributes.bidPackageName"
                        },
                        "render": function (d, type, row) {
                            let note = row.get('notes') ? row.get('notes') : '';
                            if (row.get('bidPackageId') > 0) {
                                return '<div><div class="wd-100 ' + (enableCount ? 'ht-90p' : '') + '"><div class="mb-1 fs-16">' + row.get("bidPackageName") + '</div>' + (enableCount ? '<div class="form-group mb-2 ht-75p"><textarea class="form-control wd-100 ht-100 resize-vert bid-package-notes" data-cid="' + row.cid + '">' + note + '</textarea></div></div></div>' : '');
                            } else {
                                return '<span>' + row.get('bidPackageName') + '</span>'
                            }
                        },
                        "title": "Bid Package",
                    });
                    break;
                case 'bidPackageCount':
                    columns.push({
                        "columnData": "count",
                        "data": "attributes.count",
                        "width": "10%",
                        "render": function (data, type, row) {
                            let count = row.get('count');
                            if (row.get('bidPackageId') > 0) {
                                let html = `<select class="form-control bid-package-count" style="min-width:40px;">`
                                for (let i = 0; i <= 10; i++) {
                                    if (parseInt(count) === i) {
                                        html += `<option value="` + i + `" selected>` + i + `</option>`
                                    } else {
                                        html += `<option value="` + i + `">` + i + `</option>`
                                    }
                                }
                                if (count && count.toLowerCase() === 'designated') {
                                    html += `<option value="designated" selected>Designated</option>`
                                } else {
                                    html += `<option value="designated">Designated</option>`
                                }
                                html += `</select>`

                                return html;
                            } else {
                                return '<div></div>';
                            }
                        },
                        "title": "Count"
                    });
                    break;
                case 'bidPackageStatus':
                    columns.push({
                        "columnData": "bidPackageStatus",
                        "render": function (data, type, row) {
                            if (type === 'sort' || type === 'type')
                                return '';
                            else if (_.size(row.get('statuses')) === 0) {
                                return 'N/A';
                            }

                            let innerHtml = '';
                            _.each(row.get('statuses'), _.bind(function (status) {
                                let statusPercent = (status.count / row.get('totalParticipants')) * 100,
                                    textColor = PJQ.helpers.colorHelpers.idealLinkColorForBackground(status.backgroundColor);
                                innerHtml += '<div class="progress-bar" role="progressbar" title="' + status.status + ' (' + status.count + ')" style="background-color: ' + status.backgroundColor + ';color: ' + textColor + ';width:' + statusPercent + '%">\n' +
                                    status.count +
                                    '</div>';
                            }, this));
                            let outerHtml = '<div class="progress">';
                            outerHtml += innerHtml + '</div>';
                            return outerHtml;
                        },
                        "title": "Status",
                        "orderable": false,
                        "width": "50%"
                    });
                    break;
                case 'participantsCount':
                    columns.push({
                        "columnData": "participantCount",
                        "data": "attributes.totalParticipants",
                        "title": "Contacts",
                        "width": "40px",
                        "render": function (data) {
                            return '<div class="text-align-center">' + data.toString() + '</div>';
                        }
                    });
                    break;
            }
        }, this));
        return columns;
    },
    getChildTableType: function () {
        return PJQ.constants.projectMessaging.views.BIDPKGS_CONT;
    },
    getChildTableSettings: function () {
        return this.options.projectMessagingView.options.settings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {
        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.userSettings;
        childOpts.projectMessagingView = this.options.projectMessagingView;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return new PJQ.views.projects.ProjectMessagingContactDataTable(childOpts);
    },
    onBidPackageCountChanged: function (e) {
        let $target = $(e.currentTarget),
            count = $target.val().toLowerCase(),
            row = this.getRow($target.closest('tr')),
            data = row.data();

        data.set('count', count);
        this.updateBidPackageNotesCount(data.get('bidPackageId'), data.get('notes'), count);
    },
    onBidPackageNotesChanged: function (e) {
        let $target = $(e.currentTarget),
            notes = $target.val(),
            row = this.getRow($target.closest('tr')),
            data = row.data();

        data.set('notes', notes);
        this.updateBidPackageNotesCount(data.get('bidPackageId'), notes, data.get('count'));
    },
    updateBidPackageNotesCount: function (bidPackageId, notes, count) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.get('projectId')
                },
                {
                    endpoint: 'bidpackages',
                    value: bidPackageId
                },
            ]),
            data: {
                notes: notes,
                count: count
            }
        }).put().done(_.bind(function (response) {
            PJQ.notifications.notify.successNotify({
                message: 'Bid Package Successfully Updated'
            });
        }, this));
    },
    getRowChildData: function (row) {
        let searchFor = this.options.projectMessagingView.getSearchFor(),
            statusFilter = [...this.options.projectMessagingView.options.filter.status];

        if (this.options.projectMessagingView.options.filter.isDelivered)
            statusFilter.push('DELIVERED');

        if (this.options.projectMessagingView.options.filter.isOpened)
            statusFilter.push('OPENED');

        if (this.options.projectMessagingView.options.filter.isVisited)
            statusFilter.push('VISITED');

        if (this.options.projectMessagingView.options.filter.isDownloaded)
            statusFilter.push('DOWNLOADS');

        if (this.options.projectMessagingView.options.filter.isPrintOrder)
            statusFilter.push('ORDERS ONLY');

        if (this.options.projectMessagingView.options.filter.publicPrivate)
            statusFilter.push(this.options.projectMessagingView.options.filter.publicPrivate);

        _.each(this.options.projectMessagingView.options.filter.laborStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        _.each(this.options.projectMessagingView.options.filter.minorityStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        return new PJQ.collections.projectParticipants.ProjectParticipantsForView(null, {
            project: PJQ.app.session.project,
            view: this.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP ? PJQ.constants.projectMessaging.views.COMP : PJQ.constants.projectMessaging.views.CONT,
            groupIdList: '',
            statusFilter: _.uniq(statusFilter).join(','),
            searchFor: searchFor,
            isPerGroup: false,
            withCustomFields: this.getChildTableSettings().hasCustomFields,
            bidPackageId: row.data().get('bidPackageId') > 0 ? row.data().get('bidPackageId') : -1
        });
    },
    selectAll: function (e) {
        let loader = new PJQ.Loader($('.nav-body'));
        let isSelected = $(e.currentTarget).prop('checked');
        this.options.projectMessagingView.options.isTradesViewSelectAll = isSelected;
        this.options.projectMessagingView.options.selectedContacts = [];
        if (isSelected) {
            // get company/contact list for project, iterate through it and add any that aren't declined (unless enabledeclined is true)
            this.options.projectMessagingView.getViewData('contact', _.bind(function (data) {
                let enableDeclined = this.options.projectMessagingView.isEnableDeclined();
                _.each(data.models, _.bind(function (model) {


                    let isDeclined = (this.options.projectStatusList[1].toString().split(',')[0].toLowerCase() === model.get('status').toString().toLowerCase());
                    if ((enableDeclined || !isDeclined) && !model.attributes.isBlacklisted && !model.attributes.isCompanyBlacklisted)
                        this.options.projectMessagingView.options.selectedContacts.push(model.id);


                }, this));

                this.options.projectMessagingView.options.selectedContacts = _.uniq(this.options.projectMessagingView.options.selectedContacts);
                this.options.projectMessagingView.renderContactStats();
                this.options.projectMessagingView.renderView();
                loader.remove();
            }, this), {isPerGroup: true});
        } else {
            // clear any visible checkboxes in sub-grids
            this.$('.select-company,.select-contact').prop('checked', false);
            loader.remove();
        }

        this.options.projectMessagingView.renderContactStats();
    }
});

PJQ.views.projects.ProjectMessagingMessagesDataTable = PJQ.views.projects.ProjectMessagingDataTable.extend({
    events: {
        'click i.message-toggle-row': 'childRowToggle',
        'click .btn-show-message': 'showRowFullMessage',
        'click .btn-view-attachments': 'viewAttachments'
    },
    getContextMenuItems: function () {
        return [
            {
                name: 'Resend Message',
                iconClass: 'fal fa-paper-plane',
                onClick: _.bind(function (row) {
                    new PJQ.views.modals.YesNo({
                        header: "Resend Message",
                        body: "Are you sure you want to resend this message to all participants?",
                        onYes: _.bind(function () {
                            let enableDeclined = this.options.projectMessagingView.isEnableDeclined();
                            new PJQ.ajax.Request({
                                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                    {
                                        endpoint: 'projects',
                                        value: PJQ.app.session.project.id
                                    },
                                    {
                                        endpoint: 'projectmessages',
                                        value: row.data().attributes.projectMessageId
                                    },
                                    {
                                        endpoint: 'resend'
                                    }
                                ], [
                                    {
                                        parameter: 'resendAll',
                                        value: true
                                    },
                                    {
                                        parameter: 'enableDeclined',
                                        value: enableDeclined
                                    }
                                ])
                            }).post().done(_.bind(function (data) {
                                PJQ.notifications.notify.successNotify({
                                    message: 'Message is being resent.'
                                });
                            }, this));

                        }, this)
                    });


                }, this),
                isShown: _.bind(function (row) {
                    return ((this.options.view === PJQ.constants.projectMessaging.views.MSGCONT) && (row.data().get('projectMessageId') > 0));
                }, this)
            },
            {
                name: 'Copy Message',
                iconClass: 'fal fa-copy',
                onClick: _.bind(function (row) {
                    this.options.projectMessagingView.copyProjectMessage(row.data().get('projectMessageId'));
                }, this),
                isShown: _.bind(function (row) {
                    return (row.data().get('projectMessageId') > 0);
                }, this)
            },
            {
                name: 'Export Message',
                iconClass: 'fal fa-copy',
                onClick: _.bind(function (row) {
                    this.export(row.data());
                }, this),
                isShown: _.bind(function (row) {
                    return (row.data().get('projectMessageId') > 0);
                }, this)
            },
            {
                name: 'Delete Message',
                iconClass: 'fal fa-trash',
                onClick: _.bind(function (row) {
                    new PJQ.views.modals.DeleteCancel({
                        header: "Delete Message",
                        body: "Are you sure you want to delete this message?",
                        onDelete: _.bind(function () {
                            this.options.projectMessagingView.deleteProjectMessage(row.data().get('projectMessageId'), _.bind(this.options.projectMessagingView.renderView, this.options.projectMessagingView));
                        }, this)
                    });
                }, this),
                isShown: _.bind(function (row) {
                    return (row.data().get('projectMessageId') > 0);
                }, this)
            }
        ];
    },
    export: function (message) {
        PJQ.app.session.fetchProjectMessageEmailTemplates(_.bind(function (templates) {
            this.options.project = PJQ.app.session.project;
            _.each(templates.models, function (temp) {
                if (temp.get('templateName') === message.get('templateName')) {
                    this.tempKey = temp.get('templateKey');
                }
            }, this)

            let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.get('projectId')
                },
                {
                    endpoint: 'projectmessagepreview'
                }
            ], [
                {
                    parameter: "templateKey",
                    value: this.tempKey
                }
            ]);
            new PJQ.ajax.Request({
                endpoint: endpoint
            }).post().done(_.bind(function (data) {
                this.options.tokens = data
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'projects',
                            value: this.options.project.get('projectId')
                        },
                        {
                            endpoint: 'sendprojectmessages',
                            value: message.get('projectMessageId')
                        },
                        {
                            endpoint: 'export'
                        }
                    ]),
                    data: {
                        responseType: encodeURIComponent(this.options.tokens.projectMessage.responseType),
                        responseDueDate: this.options.tokens.projectMessage.responseDueDate,
                        templateKey: this.tempKey
                    }
                }).post().success(_.bind(function (data) {
                    PJQ.files.downloadFile(data.url, {isEndpoint: false});
                }, this));
            }, this)).fail(function () {
            });
        }, this));
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['templateName', 'message', 'bidsDue', 'responseType', 'broadcastStatus', 'messageStatus', 'totalParticipants', 'sentBy', 'sentOn'];

        if (!includeAllColumns) {

            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            columns.push({
                "width": '15px',
                "columnData": "messageContacts",
                "data": null,
                "title": "",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": function (data, type, row) {
                    return '<i class="fal fa-plus-circle message-toggle-row" data-type="projectMessageId" data-id="' + row.get('projectMessageId') + '"></i>';
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'templateName':
                    columns.push({
                        "columnData": "templateName",
                        "data": "attributes.templateName",
                        "title": "Type"
                    });
                    break;
                case 'message':
                    columns.push({
                        "columnData": "message",
                        "data": "attributes.message",
                        "title": "Message",
                        "orderable": false,
                        "render": function (data, type, row) {
                            let html = '<div class="d-flex align-items-center">';
                            if (row.attributes.message && row.attributes.message !== "") {
                                html += '<div class="flex-fill">';
                                if (_.size(row.attributes.message) > 40) {
                                    html += '<a href="javascript:void(0)" data-id=" ' + row.attributes.projectMessageId + '" class="btn-show-message" title="Click to view full message">' + row.attributes.message.substr(0, 40) + '...</a>'
                                } else {
                                    html += data;
                                }
                                html += '</div>';

                                if (_.size(row.attributes.attachments) > 0) {
                                    html += '<div class=""><button type="button" class="btn btn-transparent-dark btn-view-attachments" title="View ' + _.size(row.attributes.attachments) + ' Attachments" ><i class="fal fa-sm fa-paperclip text-dark"></i></button></div>';
                                }
                            }
                            html += '</div>';
                            return html;
                        }
                    });
                    break;
                case 'bidsDue':
                    columns.push({
                        "columnData": "bidsDue",
                        "data": "attributes.bidsDue",
                        "title": "Response Due",
                        "render": function (data, type, row) {
                            let value = '';
                            if (data) {
                                value = PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                            }
                            return value;
                        }
                    });
                    break;
                case 'responseType':
                    columns.push({
                        "columnData": "responseType",
                        "data": "attributes.responseType",
                        "title": "Response Type",
                        "render": function (data, type, row) {
                            let value = 'N/A';
                            if (data === 'PROJECT')
                                value = 'Accept/Decline';
                            if (data === 'MESSAGE')
                                value = 'Yes/No';
                            return value;
                        }
                    });
                    break;
                case 'broadcastStatus':
                    columns.push({
                        "columnData": "broadcastStatus",
                        "render": function (data, type, row) {
                            if (type === 'sort' || type === 'type')
                                return '';

                            let innerHtml = '';
                            _.each(row.get('broadcastStatuses'), _.bind(function (status) {
                                let statusPercent = (status.count / row.get('totalParticipants')) * 100,
                                    foregroundColor = PJQ.helpers.colorHelpers.idealLinkColorForBackground(status.backgroundColor);
                                innerHtml += '<div class="progress-bar" role="progressbar" title="' + status.status + ' (' + status.count + ')" style="background-color: ' + status.backgroundColor + ';color: ' + foregroundColor + ';width:' + statusPercent + '%">\n' +
                                    status.count +
                                    '</div>';
                            }, this));
                            let outerHtml = '<div class="progress">';
                            outerHtml += innerHtml + '</div>';
                            return outerHtml;
                        },
                        "title": "Broadcast Status",
                        "orderable": false
                    });
                    break;
                case 'messageStatus':
                    columns.push({
                        "columnData": "messageStatus",
                        "render": function (data, type, row) {
                            if (type === 'sort' || type === 'type')
                                return '';

                            let innerHtml = '';
                            _.each(row.get('messageStatuses'), _.bind(function (status) {
                                let statusPercent = (status.count / row.get('totalParticipants')) * 100,
                                    foregroundColor = PJQ.helpers.colorHelpers.idealLinkColorForBackground(status.backgroundColor);
                                innerHtml += '<div class="progress-bar" role="progressbar" title="' + status.status + ' (' + status.count + ')" style="background-color: ' + status.backgroundColor + ';color: ' + foregroundColor + ';width:' + statusPercent + '%">\n' +
                                    status.count +
                                    '</div>';
                            }, this));
                            let outerHtml = '<div class="progress">';
                            outerHtml += innerHtml + '</div>';
                            return outerHtml;
                        },
                        "title": "Response",
                        "orderable": false
                    });
                    break;
                case 'totalParticipants':
                    columns.push({
                        "columnData": "totalParticipants",
                        "data": "attributes.totalParticipants",
                        "title": "Contacts",
                        "render": function (data) {
                            return '<div class="text-align-center">' + data.toString() + '</div>';
                        }
                    });
                    break;
                case 'sentOn':
                    columns.push(
                        // There is no way to modify messages view columns currently, so just add sentBy column with sentOn.
                        // If we ever add a way to modify columns for messages then we'll want to add a case for it.
                        {
                            "columnData": "sentBy",
                            "data": "attributes.sentBy",
                            "title": "Sent By",
                            "render": function (data, type, row) {
                                let result = '';
                                if (data != null && data.id !== 0) {
                                    return PJQ.helpers.contacts.getContactAnchor({contact: data});
                                } else {
                                    result = 'N/A';
                                }
                                return result;
                            }
                        },
                        {
                            "columnData": "sentOn",
                            "data": "attributes.sentOn",
                            "title": "Sent On",
                            "render": function (data, type, row) {

                                if (type === 'sort')
                                    return data ? data : '2222-01-01T01:01:01.01Z';

                                let value = '';
                                if (data) {
                                    value = PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, false);
                                }
                                return value;
                            }
                        });
                    break;
            }
        }, this));

        return columns;
    },
    viewAttachments: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            row = this.getRow(tr);

        new PJQ.views.projects.dashboard.ViewMessageAttachmentsModal({
            attachments: row.data().get('attachments')
        });
    },
    showRowFullMessage: function (e) {
        let $target = $(e.currentTarget),
            message = _.find(this.options.data, function (data) {
                return data.attributes.projectMessageId === parseInt($target.data('id'));
            });
        e.target.outerHTML = message.attributes.message;
    },
    getChildTableType: function () {
        return PJQ.constants.projectMessaging.views.MSGCONT_CONT;
    },
    getChildTableSettings: function () {
        return this.options.projectMessagingView.options.settings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {
        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.userSettings;
        childOpts.projectMessagingView = this.options.projectMessagingView;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return new PJQ.views.projects.ProjectMessagingContactDataTable(childOpts);
    },
    getRowChildData: function (row) {
        let searchFor = this.options.projectMessagingView.getSearchFor(),
            statusFilter = [...this.options.projectMessagingView.options.filter.status];

        if (this.options.projectMessagingView.options.filter.isDelivered)
            statusFilter.push('DELIVERED');

        if (this.options.projectMessagingView.options.filter.isOpened)
            statusFilter.push('OPENED');

        if (this.options.projectMessagingView.options.filter.isVisited)
            statusFilter.push('VISITED');

        if (this.options.projectMessagingView.options.filter.isDownloaded)
            statusFilter.push('DOWNLOADS');

        if (this.options.projectMessagingView.options.filter.isPrintOrder)
            statusFilter.push('ORDERS ONLY');

        if (row.data().get('projectMessageId') === 0)
            statusFilter.push('UNSENT');

        if (this.options.projectMessagingView.options.filter.publicPrivate)
            statusFilter.push(this.options.projectMessagingView.options.filter.publicPrivate);

        _.each(this.options.projectMessagingView.options.filter.laborStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        _.each(this.options.projectMessagingView.options.filter.minorityStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        return new PJQ.collections.projectParticipants.ProjectParticipantsForView(null, {
            project: PJQ.app.session.project,
            view: PJQ.constants.projectMessaging.views.CONT,
            projectMessageId: row.data().get('projectMessageId'),
            responseType: row.data().get('responseType'),
            statusFilter: _.uniq(statusFilter).join(','),
            searchFor: searchFor,
            withCustomFields: this.getChildTableSettings().hasCustomFields
        });
    },
    afterDataTableRenderChild: function () {
        if (this.options.projectMessagingView && this.options.projectMessagingView.options.viewProjectMessageId) {
            let page_info = this.dataTable.page.info(),
                new_row_index = this.dataTable.row(_.bind(function (idx, data, node) {
                    return data.get('projectMessageId') == this.options.projectMessagingView.options.viewProjectMessageId;
                }, this)).index(),
                row_position = this.dataTable.rows({search: 'applied'})[0].indexOf(new_row_index);

            if (!(row_position >= page_info.start && row_position < page_info.end) && row_position > -1) {
                let page_to_display = Math.floor(row_position / this.dataTable.page.len());
                this.dataTable.page(page_to_display).draw(false);
            }

            if (row_position > -1)
                this.childRowToggle({currentTarget: this.$dataTable.find('i.message-toggle-row[data-id="' + this.options.projectMessagingView.options.viewProjectMessageId + '"]')});

            this.options.projectMessagingView.options.viewProjectMessageId = null;
        }
    }
});

PJQ.views.projects.ProjectMessagingResponsesDataTable = PJQ.views.projects.ProjectMessagingDataTable.extend({
    events: {
        'click i.response-toggle-row': 'childRowToggle'
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [], includeColumns = ['status', 'totalParticipants'];

        if (!includeAllColumns) {

            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            columns.push({
                "width": '15px',
                "columnData": "responseContacts",
                "data": null,
                "title": "",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": function (data, type, row) {
                    return '<i class="fal fa-plus-circle response-toggle-row" data-type="status" data-id="' + row.get('status') + '"></i>';
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.status",
                        "title": "Response",
                        "orderable": false
                    });
                    break;
                case 'totalParticipants':
                    columns.push({
                        "columnData": "totalParticipants",
                        "data": "attributes.totalParticipants",
                        "title": "Contacts",
                        "orderable": false,
                        "render": function (data) {
                            return '<div class="text-align-center">' + data.toString() + '</div>';
                        }
                    });
                    break;
            }
        }, this));

        return columns;
    },
    getChildTableType: function () {
        return this.options.view + '-contact';
    },
    getChildTableSettings: function () {
        return this.options.projectMessagingView.options.settings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {
        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.userSettings;
        childOpts.projectMessagingView = this.options.projectMessagingView;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return new PJQ.views.projects.ProjectMessagingContactDataTable(childOpts);
    },
    getRowChildData: function (row) {
        let searchFor = this.options.projectMessagingView.getSearchFor(),
            statusFilter = [];

        statusFilter.push(row.data().get('status'));

        if (this.options.projectMessagingView.options.filter.isDelivered)
            statusFilter.push('DELIVERED');

        if (this.options.projectMessagingView.options.filter.isOpened)
            statusFilter.push('OPENED');

        if (this.options.projectMessagingView.options.filter.isVisited)
            statusFilter.push('VISITED');

        if (this.options.projectMessagingView.options.filter.isDownloaded)
            statusFilter.push('DOWNLOADS');

        if (this.options.projectMessagingView.options.filter.isPrintOrder)
            statusFilter.push('ORDERS ONLY');

        if (this.options.projectMessagingView.options.filter.publicPrivate)
            statusFilter.push(this.options.projectMessagingView.options.filter.publicPrivate);

        _.each(this.options.projectMessagingView.options.filter.laborStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        _.each(this.options.projectMessagingView.options.filter.minorityStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        return new PJQ.collections.projectParticipants.ProjectParticipantsForView(null, {
            project: PJQ.app.session.project,
            view: PJQ.constants.projectMessaging.views.CONT,
            statusFilter: _.uniq(statusFilter).join(','),
            searchFor: searchFor,
            withCustomFields: this.getChildTableSettings().hasCustomFields
        });
    }
});

PJQ.views.projects.ProjectMessagingCompanyDataTable = PJQ.views.projects.ProjectMessagingDataTable.extend({
    events: {
        'click i.company-toggle-row': 'childRowToggle',
        'change select.company-project-status': 'onStatusChanged',
        'click .btn-grade-project-contact-company': 'gradeContactCompany',
        'change .select-company': 'companySelectChanged',
        'mouseover .comment-company': 'mouseoverComments',
        'mouseleave .comment-company': 'mouseleaveComments',
        'click .btn-comment-company': 'manageComments',
        'click .btn-add-comment-company': 'addComment',
        'change .select-all-companies': 'companySelectAllChanged',
        "click .btn-show-groups": "showRowGroups"
    },
    getContextMenuItems: function () {
        return [
            {
                name: 'Upload Bid Docs',
                iconClass: 'fal fa-cloud-upload',
                onClick: _.bind(function (row) {
                    new PJQ.views.projects.UploadParticipantBidDocumentsModal({
                        contact: row.data(),
                        onSave: _.bind(function () {
                            this.options.projectMessagingView.renderView();
                        }, this)
                    });
                }, this),
                isShown: _.bind(function () {
                    return PJQ.app.session.project.hasPermission('messaging.canManage') && this.options.view === PJQ.constants.projectMessaging.views.COMP;
                }, this)
            },
            {
                name: 'Remove Company',
                iconClass: 'fal fa-trash',
                isDanger: true,
                onClick: _.bind(function (row) {
                    new PJQ.views.projects.DeleteProjectParticipants({
                        title: "Remove Company",
                        body: "Are you sure you want to remove this company from this project?",
                        onDelete: _.bind(function (isRemoveFromAB) {
                            this.options.projectMessagingView.deleteContacts(_.union(row.data().get('selectableContacts'), row.data().get('declinedContacts')), isRemoveFromAB);
                        }, this)
                    });
                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.project.hasPermission('messaging.canManage');
                }, this)
            }
        ];
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['icons', 'companyName', 'unionStatus', 'sector', 'certifications', 'groupListDisplay', 'status', 'bidAmountTotal', 'commentsCompany', 'grade', 'contactCount'];
        _.each(PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
            includeColumns.push('companyCustomField_' + customField.id);
        }, this));

        if (!includeAllColumns) {

            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            if (this.options.projectMessagingView && !this.options.projectMessagingView.options.canViewBidAmount) {
                includeColumns = _.filter(includeColumns, function(column) { return column != 'bidAmountTotal' });
            }

            columns.push({
                "columnData": 'selectCompany',
                "title": '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="select-all-companies" /><div class="state"><i class="icon fal fa-check"></i> <label class="wd-0">&nbsp;</label></div></div>',
                "width": "20px",
                "data": "null",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data, type, row) {
                    let selectedContacts = _.filter(row.get('selectableContacts'), _.bind(function (contact) {
                        return this.options.projectMessagingView.isContactSelected(contact);
                    }, this));

                    _.each(row.get('declinedContacts'), _.bind(function (contact) {
                        if (this.options.projectMessagingView.isContactSelected(contact))
                            selectedContacts.push(contact);
                    }, this));

                    let isSelected = selectedContacts.length > 0,
                        isIndeterminate = isSelected && (selectedContacts.length < _.size(row.get('selectableContacts')) + _.size(row.get('declinedContacts'))),
                        enableDeclined = this.options.projectMessagingView.isEnableDeclined(),
                        isDisabled = !enableDeclined && (this.options.projectStatusList[1].toString().split(',')[0].toLowerCase() === row.get('status').toString().toLowerCase());
                    return ('<div class="text-align-center"><div class="pretty p-default p-icon p-smooth p-has-indeterminate fs-18 m-0">' +
                        '<input type="checkbox" ' + (isSelected ? ' checked ' : '') + (isDisabled ? ' disabled ' : '') + (isIndeterminate ? ' indeterminate ' : '') + ' class="select-company ' + (isIndeterminate ? ' indeterminate ' : '') + '" />' +
                        '<div class="state"><i class="icon fal fa-check-double"></i> <label class="wd-0">&nbsp;</label></div>' +
                        '<div class="state p-is-indeterminate"><i class="icon fal fa-check"></i> <label class="wd-0">&nbsp;</label></div>' +
                        '</div></div>');
                }, this)
            });

            columns.push({
                "columnData": "groupCompanyContacts",
                "data": null,
                "title": "",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": function (data, type, row) {
                    return '<i class="fal fa-plus-circle company-toggle-row" data-type="contactCompanyId" data-id="' + row.get('contactCompanyId') + '"></i>';
                }
            });
        }

        let distanceThreshold = PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_DISTANCE_ICON_THRESHOLD),
            canManage = PJQ.app.session.project.hasPermission('messaging.canManage');
        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'icons':
                    columns.push({
                        "columnData": "icons",
                        "data": null,
                        "title": 'Info',
                        "width": '50px',
                        "orderable": false,
                        "render": _.bind(function (data, type, row) {
                            let icons = [];

                            // directory stuff
                            if (row.get('networkVerificationLevel') === 1)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/select_network_icon.png' title='Select Network Member' />");
                            else if (row.get('networkVerificationLevel') === 2)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/verified_network_icon.png' title='Verified Network Member' />");
                            else if (row.get('isDirectoryContact'))
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/directory_sub.png' title='Pantera Directory Member' />");

                            if (row.get('hasPrequal')) {
                                icons.push("<i class='fas fa-check text-gold fs-18 mr-1' title='Prequalification Available'></i>");
                            }

                            let dist = row.get('distance');
                            if (typeof distanceThreshold === 'number' && dist != null && dist <= distanceThreshold) {
                                icons.push("<i class='fas fa-map-marker-check text-orange fs-18 mr-1' title='Within " + distanceThreshold.toString() + " miles'></i>");
                            }

                            return '<div class="d-flex justify-content-center">' + icons.join('') + '</div>';
                        }, this)
                    });
                    break;
                case 'companyName':
                    columns.push({
                        "columnData": "companyName",
                        "data": "attributes.companyName",
                        "title": "Company",
                    });
                    break;
                case 'unionStatus':
                    columns.push({
                        "columnData": 'unionStatus',
                        "title": 'Union Status',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isUnion'))
                                status.push('Union');
                            if (row.get('isNonUnion'))
                                status.push('Non-Union');
                            if (row.get('isPrevailingWage'))
                                status.push('Prevailing Wage');

                            if (status.length === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'sector':
                    columns.push({
                        "columnData": 'sector',
                        "title": 'Labor Sector',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isPublicSector'))
                                status.push('Public');
                            if (row.get('isPrivateSector'))
                                status.push('Private');

                            if (status.length === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'certifications':
                    columns.push({
                        "columnData": 'certifications',
                        "title": 'Certification',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isDBE'))
                                status.push('DBE');
                            if (row.get('isDVBE'))
                                status.push('DVBE');
                            if (row.get('isMBE'))
                                status.push('MBE');
                            if (row.get('isSBE'))
                                status.push('SBE');
                            if (row.get('isSDVBE'))
                                status.push('SDVBE');
                            if (row.get('isWBE'))
                                status.push('WBE');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'groupListDisplay':
                    columns.push({
                        "columnData": "groupListDisplay",
                        "data": "attributes.groupListDisplay",
                        "title": "Trades",
                        "render": function (data) {
                            let groupDisplayLimit = 0, groupArray = data ? data.split(',') : [];
                            if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_MAX_GROUP_DISPLAY)) {
                                groupDisplayLimit = parseInt(PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_MAX_GROUP_DISPLAY));
                            }

                            if (groupDisplayLimit > 0 && (_.size(groupArray) > groupDisplayLimit)) {
                                return _.rest(groupArray.reverse(), _.size(groupArray) - groupDisplayLimit).reverse().join(', ') + " <br>" +
                                    "<a href='javascript:void(0)' class='btn-show-groups' title='Click to show complete list of Trades'> " + (_.size(groupArray) - groupDisplayLimit) + " more item(s)</a>";
                            } else {
                                return data;
                            }
                        }
                    });
                    break;
                case 'status':
                    columns.push({
                        "columnData": 'status',
                        "data": {
                            "_": function (row) {
                                return row.get('status') ? row.get('status') : 'PENDING';
                            },
                            "display": function (row) {

                                if (canManage) {
                                    let html = '<select class="form-control company-project-status" style="min-width:100px;">',
                                        statuses = PJQ.app.session.project.getProjectStatusList();
                                    statuses.unshift(['PENDING', true]);
                                    _.each(statuses, _.bind(function (status, index) {
                                        html += '<option value="' + status[0] + '"' + (status[0] === row.get('status') ? ' SELECTED' : '') + '>' + status[0] + '</option>';
                                    }, this));
                                    html += '</select>';
                                    return html;
                                }

                                let status = row.get('status');
                                return '<span>' + (_.size(status) > 0 ? status.toUpperCase() : 'PENDING') + '</span>';
                            }
                        },
                        "title": 'Status',
                    });
                    break;
                case 'bidAmountTotal':
                    columns.push({
                        "columnData": "bidAmountTotal",
                        "data": "attributes.bidAmount",
                        "title": "Bid Total",
                        "render": function (data, type, row) {
                            return "<span class='bid-amount-total'>" + PJQ.helpers.formatHelpers.formatCurrency(row.get("bidAmount"))  + "</span>";
                        }
                    });
                    break;
                case 'commentsCompany':
                    columns.push({
                        "columnData": 'commentsCompany',
                        "title": 'Comments',
                        "render": function (data, type, row) {
                            let html = '<div style="min-width:150px;" class="d-flex align-items-center">';
                            html += '<div class="flex-fill comment-company ' + (row.get('lastCompanyComment') ? '' : 'text-muted') + '">' + (row.get('lastCompanyComment') ? row.get('lastCompanyComment').comment : 'No Comments Added') + '</div>';
                            html += '<button type="button" class="btn btn-transparent-dark btn-add-comment-company" title="Add Comment"><i class="far fa-comment-plus text-dark"></i></button>';
                            html += '<button type="button" class="btn btn-transparent-dark btn-comment-company" title="Comments" data-contact-company-id="' + row.get('contactCompanyId') + '"><i class="far fa-comments text-dark"></i></button>';
                            html += '</div>';
                            return html;
                        }
                    });
                    break;
                case 'grade':
                    columns.push({
                        "columnData": 'grade',
                        "title": 'Grade',
                        "width": "40px",
                        "render": function (data, type, row) {
                            let html = '<span class="mr-1">' + row.get('gradeAverage').toString() + '</span>';
                            //todo: add preference for this
                            if (PJQ.app.session.get('portalId') !== 506) {
                                html += (row.get('grade') !== 0) ? '<button type="button" class="btn btn-transparent-dark btn-grade-project-contact-company" title="Review Grade" data-contact-company-id="' + row.get('contactCompanyId') + '"><i class="fas fa-star text-gold"></i></button>' : '<button type="button" class="btn btn-transparent-dark btn-grade-project-contact-company" title="Grade" data-contact-company-id="' + row.get('contactCompanyId') + '"><i class="far fa-star text-muted"></i></button>';
                            }
                            return html;
                        }
                    });
                    break;
                case 'contactCount':
                    columns.push({
                        "columnData": "contactCount",
                        "data": "attributes.contactCount",
                        "title": "Contacts",
                        "render": function (data) {
                            return '<div class="text-align-center">' + data.toString() + '</div>';
                        }
                    });
                    break;
            }

            if (columnName.startsWith('companyCustomField_')) {
                let customFieldId = parseInt(columnName.substring(columnName.indexOf('_') + 1));
                _.each(PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
                    if (customField.id === customFieldId)
                        columns.push(this.getCustomFieldColumn(customField, true));
                }, this));
            }
        }, this));

        return columns;
    },
    afterDataTableRenderChild: function () {
        this.$el.find('.select-company.indeterminate').prop('indeterminate', 'true');
    },
    getChildTableType: function () {
        return this.options.view + '-contact';
    },
    getChildTableSettings: function () {
        return this.options.projectMessagingView.options.settings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {
        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.userSettings;
        childOpts.projectMessagingView = this.options.projectMessagingView;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return new PJQ.views.projects.ProjectMessagingContactDataTable(childOpts);
    },
    getRowChildData: function (row) {
        let searchFor = this.options.projectMessagingView.getSearchFor(),
            statusFilter = [...this.options.projectMessagingView.options.filter.status];

        if (this.options.projectMessagingView.options.filter.isDelivered)
            statusFilter.push('DELIVERED');

        if (this.options.projectMessagingView.options.filter.isOpened)
            statusFilter.push('OPENED');

        if (this.options.projectMessagingView.options.filter.isVisited)
            statusFilter.push('VISITED');

        if (this.options.projectMessagingView.options.filter.isDownloaded)
            statusFilter.push('DOWNLOADS');

        if (this.options.projectMessagingView.options.filter.isPrintOrder)
            statusFilter.push('ORDERS ONLY');

        if (this.options.projectMessagingView.options.filter.publicPrivate)
            statusFilter.push(this.options.projectMessagingView.options.filter.publicPrivate);

        _.each(this.options.projectMessagingView.options.filter.laborStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        _.each(this.options.projectMessagingView.options.filter.minorityStatus, _.bind(function (status) {
            statusFilter.push('IS_' + status);
        }, this));

        return new PJQ.collections.projectParticipants.ProjectParticipantsForView(null, {
            project: PJQ.app.session.project,
            view: PJQ.constants.projectMessaging.views.CONT,
            contactCompanyId: row.data().get('contactCompanyId'),
            statusFilter: _.uniq(statusFilter).join(','),
            searchFor: searchFor,
            groupIdList: row.data().collection.options.groupIdList,
            isPerGroup: row.data().collection.options.isPerGroup,
            withCustomFields: this.getChildTableSettings().hasCustomFields
        });
    },
    statusChanged: function (statuses, parentTR) {
        let row = this.getRow(parentTR);
        switch (this.options.view) {
            case PJQ.constants.projectMessaging.views.COMP:
                // this view cannot have a group status, so update the regular status column and redraw the row.
                row.data().set('status', statuses.companyStatus);
                break;
            case PJQ.constants.projectMessaging.views.GROUPCOMP_COMP:
                // this view must have a group status
                row.data().set('status', statuses.companyGroupStatus);
                break;
        }
        row.invalidate().draw();
        this.setRowStyle(parentTR, row.data().get('status'), row.data().get('isBlacklisted') || row.data().get('isCompanyBlacklisted'));
    },
    companySelectChanged: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            row = this.getRow(tr);

        // if we were partially checked, force ourself to be unchecked
        if ($(e.currentTarget).hasClass('indeterminate'))
            $(e.currentTarget).prop('checked', false).prop('indeterminate', false).removeClass('indeterminate');

        if ($(e.currentTarget).prop('checked')) {
            if (row.data().get('declinedContacts').length > 0)
                $(e.currentTarget).prop('checked', false).prop('indeterminate', true).addClass('indeterminate');
            else
                $(e.currentTarget).prop('indeterminate', false).removeClass('indeterminate');

            if (_.size(row.data().get('selectableContacts')) > 0)
                this.options.projectMessagingView.addSelectedContacts(row.data().get('selectableContacts'));
            else
                $(e.currentTarget).prop('checked', false);

            if (this.options.parentDataTable && this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP) {
                let groupId = parseInt(row.data().collection.options.groupIdList), contactGroups = [];
                _.each(row.data().get('selectableContacts'), _.bind(function (contact) {
                    contactGroups.push({contactId: contact, groupId: groupId});
                }, this));
                this.options.projectMessagingView.addSelectedContactGroups(contactGroups);
            }
        } else {
            this.options.projectMessagingView.removeSelectedContacts(_.union(row.data().get('selectableContacts'), row.data().get('declinedContacts')));

            if (this.options.parentDataTable && this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP) {
                let groupId = parseInt(row.data().collection.options.groupIdList), contactGroups = [];
                _.each(_.union(row.data().get('selectableContacts'), row.data().get('declinedContacts')), _.bind(function (contact) {
                    contactGroups.push({contactId: contact, groupId: groupId});
                }, this));
                this.options.projectMessagingView.removeSelectedContactGroups(contactGroups);
            }
        }

        _.each(this.options.childDataTables, _.bind(function (childDT) {
            if (row.data().get('contactCompanyId') !== childDT.$el.data('id'))
                return;

            _.each(childDT.$el.find('.select-contact'), _.bind(function (input) {
                let childRow = childDT.getRow($(input).closest('tr'));
                $(input).prop('checked', this.options.projectMessagingView.isContactSelected(childRow.data().get('contactId')));
            }, this));

        }, this));

    },
    companySelectAllChanged: function (e) {
        let projectStatusList = PJQ.app.session.project.getProjectStatusList(),
            isChecked = $(e.currentTarget).prop('checked'),
            isEnableDeclined = this.options.projectMessagingView.isEnableDeclined(), selectedContacts = [];

        _.each(this.dataTable.data(), _.bind(function (row) {
            if (isChecked) {
                if (!row.attributes.isBlacklisted)
                    $.merge(selectedContacts, row.attributes.selectableContacts);

                if (isEnableDeclined)
                    $.merge(selectedContacts, row.attributes.declinedContacts);
            } else {
                $.merge(selectedContacts, row.attributes.selectableContacts);
                $.merge(selectedContacts, row.attributes.declinedContacts);
            }
        }, this));

        let selectedContactGroups = [], isGroupsView = false;
        if (this.options.parentDataTable && this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP) {
            let groupId = parseInt(this.options.data[0].collection.options.groupIdList);
            _.each(selectedContacts, _.bind(function (contact) {
                selectedContactGroups.push({contactId: contact, groupId: groupId});
            }, this));
            isGroupsView = true;
        }

        if (isChecked) {
            this.options.projectMessagingView.addSelectedContacts(selectedContacts);

            if (isGroupsView)
                this.options.projectMessagingView.addSelectedContactGroups(selectedContactGroups);
        } else {
            this.options.projectMessagingView.removeSelectedContacts(selectedContacts);

            if (isGroupsView)
                this.options.projectMessagingView.removeSelectedContactGroups(selectedContactGroups);
        }

        _.each(this.$dataTable.find('tbody tr[role="row"]'), _.bind(function (tr) {
            let row = this.getRow(tr), input = $(tr).find('input.select-company');

            if (input.length === 0)
                return;

            // if is declined, skip it unless enable declined is turned on
            $(input).prop('indeterminate', false).removeClass('indeterminate');
            if ($(e.currentTarget).prop('checked') === false || (!isEnableDeclined && projectStatusList[1].toString().split(',')[0].toLowerCase() === row.data().get('status').toString().toLowerCase()) || _.size(selectedContacts) == 0)
                $(input).prop('checked', false);
            else {
                $(input).prop('checked', $(e.currentTarget).prop('checked'));

                if (row.data().get('declinedContacts').length > 0 && !isEnableDeclined)
                    $(input).prop('indeterminate', true).addClass('indeterminate');
            }


        }, this));

        _.each(this.options.childDataTables, _.bind(function (childDT) {
            _.each(childDT.$el.find('.select-contact'), _.bind(function (input) {
                let childRow = childDT.getRow($(input).closest('tr'));
                $(input).prop('checked', this.options.projectMessagingView.isContactSelected(childRow.data().get('contactId')));
            }, this));
        }, this));

        this.refresh(false);
    },
    createdRow: function (row, data, dataIndex) {
        this.setRowStyle(row, data.attributes.status, data.attributes.isBlacklisted)
    },
    setRowStyle: function (row, status, isBlacklisted) {
        let statusColor = _.find(this.options.projectMessagingView.options.settings.attributes.statusColors, function (statusColor) {
            return statusColor.status === status
        });

        let blackListed = '';
        if (isBlacklisted)
            blackListed = 'text-decoration: line-through !important;';

        if (statusColor) {
            let foregroundColor = PJQ.helpers.colorHelpers.idealLinkColorForBackground(statusColor.backgroundColor);
            $(row).css({cssText: 'background-color:' + statusColor.backgroundColor + ' !important;' + 'color:' + foregroundColor + ' !important;' + blackListed});
        } else
            $(row).css({cssText: "background-color: ''; color: '';" + blackListed});
    },
    showRowGroups: function (e) {
        let target = $(e.currentTarget),
            row = this.getRow(target.closest('tr')),
            data = row.data(),
            groups = data.get('groupListDisplay').split(','),
            groupDisplayLimit = parseInt(PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_MAX_GROUP_DISPLAY));
        target[0].outerHTML = ' ' + _.rest(groups, groupDisplayLimit).join(', ')
    }
});

PJQ.views.projects.ProjectMessagingContactDataTable = PJQ.views.projects.ProjectMessagingDataTable.extend({
    events: {
        'click i.contact-toggle-row': 'childRowToggle',
        'change select.contact-project-status': 'onStatusChanged',
        'change select.contact-message-status': 'onMessageStatusChanged',
        'click .btn-grade-project-contact': 'gradeContactCompany',
        'mouseover .comment-contact,.comment-company': 'mouseoverComments',
        'mouseleave .comment-contact,.comment-company': 'mouseleaveComments',
        'click .btn-add-comment-contact,.btn-add-comment-company': 'addComment',
        'click .btn-comment-contact,.btn-comment-contact-company': 'manageComments',
        'keyup .contact-bid-amount': 'bidAmountChanged',
        'blur .contact-bid-amount': 'bidAmountExited',
        'change .select-contact': 'contactSelectChanged',
        'change .select-all-contacts': 'contactSelectAllChanged',
        'click .btn-copy-access-key': 'copyAccessKey',
        'click .btn-copy-phone': 'copyPhone',
        'click .btn-copy-email': 'copyEmail',
        "click .btn-show-groups": "showRowGroups"
    },
    afterDataTableRenderChild: function () {
        PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.contact-bid-amount'), 2);
    },
    getContextMenuItems: function () {
        return [
            {
                name: 'View Contact',
                iconClass: 'fal fa-search',
                onClick: _.bind(function (row) {
                    new PJQ.views.contacts.BaseEditContactModal({
                        model: new PJQ.models.projectParticipants.ProjectParticipant({
                            id: row.data().get('contactId'),
                            projectId: PJQ.app.session.project.id,
                        }),
                        showNotes: true,
                        showActive: true
                    });
                }, this),
                isShown: _.bind(function (row) {
                    return !PJQ.app.session.hasPermission('contacts.isAdmin')
                        && (PJQ.app.session.hasPermission('contacts.canView') || PJQ.app.session.project.hasPermission('projectContacts.canView'));
                }, this)
            },
            {
                name: 'Edit Contact',
                iconClass: 'fal fa-pencil',
                onClick: _.bind(function (row) {
                    new PJQ.views.contacts.BaseEditContactModal({
                        model: new PJQ.models.projectParticipants.ProjectParticipant({
                            id: row.data().get('contactId'),
                            projectId: PJQ.app.session.project.id
                        }),
                        isShowAddContact: true,
                        showNotes: true,
                        showActive: true,
                        deleteLabel: 'Remove from Project',
                        onDelete: _.bind(function (model) {
                            this.options.projectMessagingView.deleteContacts([row.data().get('contactId')], false);

                        }, this),
                        onSave: _.bind(function (model, isNew) {
                            if (isNew) {
                                this.options.projectMessagingView.renderView();
                                return;
                            }

                            let becameInactive = false;
                            if (model.get('isBlacklisted') && !row.data().get('isBlacklisted')) {
                                becameInactive = true;
                                row.data().set('status', this.options.projectStatusList[1].toString().split(',')[0]);
                            }

                            row.data().set('isAutoSelectDisabled', model.get('isAutoSelectDisabled'));
                            row.data().set('isBlacklisted', model.get('isBlacklisted'));
                            row.data().set('contactTitle', model.get('contactTitle'));
                            row.data().set('fax', model.get('fax'));
                            row.data().set('cell', model.get('cell'));
                            row.data().set('address1', model.get('address1'));
                            row.data().set('address2', model.get('address2'));
                            row.data().set('city', model.get('city'));
                            row.data().set('zip', model.get('zip'));
                            row.data().set('state', model.get('state'));
                            row.data().set('country', model.get('country'));
                            // row.data().set('groupIdList', model.get('groupIdList'));
                            // row.data().set('groupListDisplay', model.get('groupListDisplay'));
                            row.data().set('isCompanyBlacklisted', model.get('isCompanyBlacklisted'));
                            row.data().set('isUnion', model.get('isUnion'));
                            row.data().set('isNonUnion', model.get('isNonUnion'));
                            row.data().set('isPrevailingWage', model.get('isPrevailingWage'));
                            row.data().set('isPublicSector', model.get('isPublicSector'));
                            row.data().set('isPrivateSector', model.get('isPrivateSector'));
                            row.data().set('isDBE', model.get('isDBE'));
                            row.data().set('isDVBE', model.get('isDVBE'));
                            row.data().set('isMBE', model.get('isMBE'));
                            row.data().set('isSBE', model.get('isSBE'));
                            row.data().set('isSDVBE', model.get('isSDVBE'));
                            row.data().set('isUDBE', model.get('isUDBE'));
                            row.data().set('isVSBE', model.get('isVSBE'));
                            row.data().set('isWBE', model.get('isWBE'));
                            row.data().set('phone', model.get('phone'));
                            row.data().set('phoneExtension', model.get('phoneExtension'));
                            row.data().set('companyName', model.get('companyName'));
                            row.data().set('contactName', model.get('contactName'));
                            row.data().set('distance', model.get('distance'));
                            row.data().set('email', model.get('email'));
                            row.data().set('notes', model.get('notes'));
                            row.data().set('contactCustomFieldValues', model.get('contactCustomFieldValues'));
                            row.data().set('companyCustomFieldValues', model.get('companyCustomFieldValues'));

                            row.invalidate().draw();
                            this.setRowStyle(row.node(), row.data().attributes.status, row.data().attributes.isBlacklisted || row.data().attributes.isCompanyBlacklisted);

                            let removeRow = _.bind(function () {
                                    let parentRow = this.options.parentDataTable.getRow($(row.node()).parent().closest('tr').prev());
                                    row.remove().draw();

                                    // remove company if this was the only contact listed
                                    if (this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP &&
                                        parentRow.data().get('contactCount') === 1) {
                                        parentRow.remove().draw();
                                    }
                                }, this),
                                callback = _.bind(function () {
                                    if (row.child.isShown()) {
                                        row.child.hide();

                                        this.childRowToggle({
                                            currentTarget: row.selector.rows.find('i.contact-toggle-row')[0]
                                        });
                                    }

                                    if (this.options.parentDataTable && (this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP ||
                                        this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCONT)) {

                                        let groupId = parseInt(row.data().collection.options.groupIdList);
                                        if (groupId === 0) {
                                            if (_.size(model.get('groups')) > 0) {
                                                // they had no groups but now have groups, remove from no group
                                                removeRow();
                                            }
                                        } else if (_.size(_.filter(model.get('groups'), function (group) {
                                            return group.groupId === groupId
                                        })) === 0) {
                                            // they no longer have the group of the row they are being edited in
                                            removeRow();
                                        }
                                    }
                                }, this);

                            if (becameInactive && this.options.parentDataTable && (this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.COMP || this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP)) {
                                // update parent status and redraw
                                let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                                    {
                                        endpoint: 'projects',
                                        value: PJQ.app.session.project.id
                                    },
                                    {
                                        endpoint: 'participants',
                                        value: row.data().get('contactId')

                                    },
                                    {
                                        endpoint: 'companystatus'
                                    }
                                ]);
                                new PJQ.ajax.Request({
                                    endpoint: endpoint
                                }).get().done(_.bind(function (data) {
                                    let parentTR = $(row.node()).parent().closest('tr').prev();
                                    let rowParent = this.options.parentDataTable.getRow(parentTR);
                                    rowParent.data().set('status', data.status);
                                    rowParent.invalidate().draw();
                                    this.options.parentDataTable.setRowStyle(parentTR, data.status, row.data().get('isCompanyBlacklisted'));
                                    callback();

                                }, this)).fail(function () {
                                    PJQ.notifications.notify.errorNotify({
                                        message: 'Unable to get Company Status.'
                                    });
                                });
                            } else {
                                callback();
                            }

                        }, this)
                    });
                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.hasPermission('contacts.isAdmin');
                }, this)
            },
            {
                name: 'Manage Trades',
                iconClass: 'fal fa-hard-hat',
                onClick: _.bind(function (row) {
                    new PJQ.views.projects.ManageProjectParticipantTradesModal({
                        contactId: row.data().get('contactId'),
                        onSave: _.bind(function (data) {
                            // close/hide/dispose of child datatable so that it can be refreshed.  update current row's grouplist display.
                            let groupIdList = [];
                            let groupNameList = [];
                            _.each(data.models, _.bind(function (model) {
                                if (model.get('isSelected')) {
                                    groupIdList.push(model.get('groupId'));
                                    groupNameList.push(model.get('groupName'));
                                }
                            }, this));

                            row.data().set('groupIdList', groupIdList.join(','));
                            row.data().set('groupListDisplay', groupNameList.join(', '));
                            row.invalidate().draw();

                            if (row.child.isShown()) {
                                row.child.hide();

                                this.childRowToggle({
                                    currentTarget: row.selector.rows.find('i.contact-toggle-row')[0]
                                });
                            }

                        }, this)
                    });
                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.project.hasPermission('messaging.canManage') && this.options.view !== PJQ.constants.projectMessaging.views.MSGCONT_CONT;
                }, this)

            },
            {
                name: 'Project History',
                iconClass: 'fal fa-history',
                onClick: _.bind(function (row) {
                    new PJQ.views.projects.ProjectParticipantHistoryModal({
                        project: this.options.project,
                        contactId: row.data().get('contactId')
                    });
                }, this),
                isShown: _.bind(function (row) {
                    return true;
                }, this)
            },
            {
                name: 'Resend Message',
                iconClass: 'fal fa-paper-plane',
                onClick: _.bind(function (row) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'projects',
                                value: PJQ.app.session.project.id
                            },
                            {
                                endpoint: 'projectmessages',
                                value: row.data().collection.options.projectMessageId
                            },
                            {
                                endpoint: 'resend'
                            }
                        ], [
                            {
                                parameter: 'projectMessageContactBroadcastIds',
                                value: [row.data().attributes.projectMessageContactBroadcastId]
                            }
                        ])
                    }).post().done(_.bind(function (data) {
                        PJQ.notifications.notify.successNotify({
                            message: 'Message is being resent.'
                        });
                    }, this));

                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.project.hasPermission('messaging.canManage') && this.options.view === PJQ.constants.projectMessaging.views.MSGCONT_CONT;
                }, this)
            },
            {
                name: 'Upload Bid Docs',
                iconClass: 'fal fa-cloud-upload',
                onClick: _.bind(function (row) {
                    new PJQ.views.projects.UploadParticipantBidDocumentsModal({
                        contact: row.data(),
                        onSave: _.bind(function () {
                            this.options.projectMessagingView.renderView();
                        }, this)
                    });
                }, this),
                isShown: function () {
                    return PJQ.app.session.project.hasPermission('messaging.canManage');
                }
            },
            {
                name: 'Order Prints',
                iconClass: 'fal fa-shopping-cart',
                onClick: _.bind(function (row) {
                    new PJQ.views.files.OrderPrintsModal({
                        recipients: [row.data()],
                        onOrderPlaced: _.bind(function () {
                            this.options.projectMessagingView.clearSelectedContacts();
                        }, this)
                    });
                }, this),
                isShown: function () {
                    return PJQ.app.session.project.hasPermission('messaging.canManage');
                }
            },
            {
                name: 'Send Update Request',
                iconClass: 'fal fa-poll-h',
                onClick: _.bind(function (row) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'contacts',
                                value: row.data().get('contactId')
                            },
                            {
                                endpoint: 'updater'
                            }
                        ])
                    }).post().done(_.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Contact Updater Request sent'
                        });
                    }, this)).fail(function (xhr, err, result) {
                        PJQ.notifications.notify.errorNotify({
                            message: 'Contact Updater Request failed'
                        });
                    });

                }, this),
                isShown: function (row) {
                    return PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_CONTACT_UPDATER_ENABLED) &&
                        PJQ.app.session.project.hasPermission('messaging.canManage') &&
                        !row.data().get('isDirectoryContact');
                }
            },
            {
                name: 'Request Prequal',
                iconClass: 'fal fa-envelope-open-text',
                onClick: _.bind(function (row) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'contacts',
                                value: row.data().get('contactId')
                            },
                            {
                                endpoint: 'prequal'
                            },
                            {
                                endpoint: 'request'
                            }
                        ])
                    }).post().done(_.bind(function (data) {
                        if (data && data.success) {
                            PJQ.notifications.notify.successNotify({
                                message: 'Qualification request sent'
                            });
                        } else {
                            PJQ.notifications.notify.errorNotify({
                                message: 'Qualification update failed, invalid email address on contact'
                            });
                        }
                    }, this)).fail(function (xhr, err, result) {
                        new PJQ.logging.Debug(PJQ.logging.LoggingActions.SEND_PREQUAL_UPDATE, {
                            error: err,
                            result: result
                        });
                    });
                }, this),
                isShown: function () {
                    return PJQ.app.session.hasPermission('prequal.canView') && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PREQUAL);
                }
            },
            {
                name: 'Export vCard',
                iconClass: 'fal fa-address-card',
                onClick: _.bind(function (row) {
                    PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'contacts',
                            value: row.data().get('contactId')
                        },
                        {
                            endpoint: 'vcard'
                        }
                    ]));
                }, this)
            },
            {
                name: 'Copy Public Vendor',
                iconClass: 'fal fa-copy',
                onClick: _.bind(function (row) {
                    let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'contacts',
                            value: row.data().get('contactId')
                        },
                        {
                            endpoint: 'copydirectorycontact'
                        }
                    ]);
                    new PJQ.ajax.Request({
                        endpoint: endpoint
                    }).post().done(_.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Contact copied successfully.'
                        });
                        // todo: update this view and maybe parent view if parent view is a company?
                    }, this)).fail(function (xhr, err, result) {
                        let logicError = xhr.responseJSON.message.indexOf('logic') === -1;
                        PJQ.notifications.notify.errorNotify({
                            title: logicError ? 'Duplicate Contact' : 'Something went wrong!',
                            message: logicError ? 'Directory contact already exists in your address book.' : 'Something went wrong!'
                        });
                    });
                }, this),
                isShown: function (row) {
                    return PJQ.app.session.project.hasPermission('messaging.canManage') && row.data().get('isDirectoryContact');
                }
            },
            {
                name: 'Report',
                iconClass: 'fal fa-flag-alt',
                onClick: _.bind(function (row) {
                    new PJQ.views.contacts.ReportContactModal({
                        contactId: row.data().get('contactId'),
                        showRemoveFromProject: true,
                        onReport: _.bind(function (removeFromProject) {
                            if (removeFromProject)
                                this.options.projectMessagingView.renderView();
                        }, this)
                    });
                }, this),
                isShown: function (row) {
                    return PJQ.app.session.project.hasPermission('messaging.canManage') && row.data().get('isDirectoryContact');
                }
            },
            {
                name: 'Remove Contact',
                iconClass: 'fal fa-trash',
                isDanger: true,
                onClick: _.bind(function (row) {
                    new PJQ.views.projects.DeleteProjectParticipants({
                        title: "Remove Participant",
                        body: "Are you sure you want to remove this contact from this project?",
                        onDelete: _.bind(function (isRemoveFromAB) {
                            this.options.projectMessagingView.deleteContacts([row.data().get('contactId')], isRemoveFromAB);
                        }, this)
                    });
                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.project.hasPermission('messaging.canManage') && this.options.view !== PJQ.constants.projectMessaging.views.MSGCONT_CONT;
                }, this)
            }
        ];
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['icons', 'companyName', 'contactName', 'contactTitle', 'address1', 'address2', 'city', 'state', 'zip', 'country', 'phone', 'cell', 'fax', 'email', 'unionStatus', 'sector', 'certifications', 'groupListDisplay', 'distance', 'grade', 'userType', 'commentsCompany', 'commentsContact', 'bidAmount', 'status'];

        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_ACTIVITY_RANK_STATUS_LIST))
            includeColumns.push('activityRank');

        if (this.options.view === PJQ.constants.projectMessaging.views.MSGCONT_CONT) {
            includeColumns.push('accessKey');
            includeColumns.push('broadcastStatus');
            includeColumns.push('deliveredOn');
            includeColumns.push('openedOn');
            includeColumns.push('responded');
        }

        _.each(PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
            includeColumns.push('companyCustomField_' + customField.id);
        }, this));

        _.each(PJQ.app.session.customFields.contact[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
            includeColumns.push('contactCustomField_' + customField.id);
        }, this));

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            if (this.options.projectMessagingView && !this.options.projectMessagingView.options.canViewBidAmount) {
                includeColumns = _.filter(includeColumns, function(column) { return column != 'bidAmount' });
            }

            columns.push({
                "columnData": '',
                "title": (this.options.parentDataTable && (this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.COMP || this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP)) ? '' : '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="select-all-contacts" /><div class="state"><i class="icon fal fa-check"></i> <label class="wd-0">&nbsp;</label></div></div>',
                "width": "20px",
                "data": "null",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data, type, row) {
                    let isSelected = this.options.projectMessagingView.isContactSelected(row.get('contactId')),
                        enableDeclined = this.options.projectMessagingView.isEnableDeclined(),
                        isDisabled = !enableDeclined && (this.options.projectStatusList[1].toString().split(',')[0].toLowerCase() === row.get('status').toString().toLowerCase());
                    return ('<div class="text-align-center"><div class="pretty p-default p-icon p-smooth fs-18 m-0">' +
                        '<input type="checkbox"' + (isSelected ? ' checked ' : '') + (isDisabled ? ' disabled ' : '') + ' class="select-contact" />' +
                        '<div class="state"><i class="icon fal fa-check"></i> <label class="wd-0">&nbsp;</label></div>' +
                        '</div></div>');
                }, this)
            });

            if (!this.options.parentDataTable || this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.COMP || this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.RSPCONT || this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCONT || this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP) {
                columns.push({
                    "columnData": 'contactGroups',
                    "data": null,
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": function (data, type, row) {
                        return '<i class="fal fa-plus-circle contact-toggle-row" data-id="' + row.get('contactId') + '"></i>';
                    }
                });
            }
        }

        let maxEmailWidth = $(window).width() > 1200 ? 225 : 100,
            canManage = PJQ.app.session.project.hasPermission('messaging.canManage'),
            distanceThreshold = PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_DISTANCE_ICON_THRESHOLD);
        _.each(includeColumns, _.bind(function (columnName) {
            let cName,
                cNameTp = typeof columnName;
            if (cNameTp === 'string') {
                cName = columnName;
            } else if (cNameTp === 'object' && typeof cNameTp.data === 'string') {
                cName = cNameTp.data;
            } else {
                return;
            }
            switch (cName) {
                case 'icons':
                    columns.push({
                        "columnData": "icons",
                        "data": null,
                        "title": 'Info',
                        "width": '50px',
                        "orderable": false,
                        "render": _.bind(function (data, type, row) {
                            let icons = [];

                            if (row.get('isDefaultContact'))
                                icons.push("<i class='far fa-crown mr-1' title='Primary Contact'></i>");

                            // proqual stuff
                            if (row.get('hasUnpaidInvites'))
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/screening_pending.gif' title='Qualification Pending' />");
                            else if (row.get('minScreeningStatusId') < PJQ.constants.proQual.screeningStatuses.Complete &&
                                row.get('maxScreeningInviteId') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/screening_inprocess.gif' title='Qualification In Process' />");
                            else if (row.get('minScreeningStatusId') >= PJQ.constants.proQual.screeningStatuses.Complete &&
                                row.get('maxScreeningInviteId') > 0 && row.get('minScreeningGradeId') === 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/screening_review.gif' title='Qualification Needs Review' />");
                            else if (row.get('minScreeningStatusId') >= PJQ.constants.proQual.screeningStatuses.Complete &&
                                row.get('maxScreeningInviteId') > 0 && row.get('minScreeningGradeId') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/screening_allclear.png' title='Qualification Approved' />");
                            else if (row.get('minScreeningStatusId') >= PJQ.constants.proQual.screeningStatuses.InProcess &&
                                row.get('maxScreeningInviteId') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/screening_processed.gif' title='All Enrolled' />");

                            if (row.get('maxScreeningInviteId') > 0 && row.get('screeningCountFeedbackItems') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/screening_grade2.gif' title='Qualification Feedback Required' />");

                            if (row.get('maxScreeningInviteId') > 0 && new Date(row.get('maxInviteExpiresOn')) < new Date())
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/screening_expired.png' title='Qualification Expired' />");

                            // directory stuff
                            if (row.get('networkVerificationLevel') === 1)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/select_network_icon.png' title='Select Network Member' />");
                            else if (row.get('networkVerificationLevel') === 2)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/verified_network_icon.png' title='Verified Network Member' />");
                            else if (row.get('isDirectoryContact'))
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/directory_sub.png' title='Pantera Directory Member' />");

                            // message stats stuff

                            if (row.get('lastDownloadedOn'))
                                icons.push("<i class='far fa-download mr-1' title='Last downloaded on " + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('lastDownloadedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "'></i>");
                            else if (row.get('lastViewedOn') && (!this.options.parentDataTable || this.options.parentDataTable.options.view !== PJQ.constants.projectMessaging.views.MSGCONT))
                                icons.push("<i class='far fa-eye mr-1' title='Last visited on " + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('lastViewedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "'></i>");
                            else if (row.get('viewedOn') && this.options.parentDataTable && this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.MSGCONT)
                                icons.push("<i class='far fa-eye mr-1' title='Visited on " + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('viewedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "'></i>");
                            else if (row.get('openedOn') && this.options.parentDataTable && this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.MSGCONT)
                                icons.push("<i class='far fa-envelope-open  mr-1' title='Opened email on " + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('openedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "'></i>");
                            else if (row.get('lastOpenedOn') && (!this.options.parentDataTable || this.options.parentDataTable.options.view !== PJQ.constants.projectMessaging.views.MSGCONT))
                                icons.push("<i class='far fa-envelope-open  mr-1' title='Last opened email on " + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('lastOpenedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "'></i>");
                            else if (row.get('deliveredOn') && this.options.parentDataTable && this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.MSGCONT)
                                icons.push("<i class='far fa-envelope  mr-1' title='Delivered on " + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('deliveredOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "'></i>");
                            else if (row.get('lastDeliveredOn') && (!this.options.parentDataTable || this.options.parentDataTable.options.view !== PJQ.constants.projectMessaging.views.MSGCONT))
                                icons.push("<i class='far fa-envelope  mr-1' title='Last delivered email on " + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('lastDeliveredOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "'></i>");

                            if (row.get('lastBroadcastStatus') && (row.get('lastBroadcastStatus').toLowerCase().indexOf('fail') !== -1 || row.get('lastBroadcastStatus').toLowerCase().indexOf('error') !== -1))
                                icons.push("<i class='far fa-exclamation-triangle  mr-1' title='Last Message Failed'></i>");

                            let dist = row.get('distance');
                            if (typeof distanceThreshold === 'number' && dist != null && dist <= distanceThreshold) {
                                icons.push("<i class='fas fa-map-marker-check text-orange fs-18 mr-1' title='Within " + distanceThreshold.toString() + " miles'></i>");
                            }

                            return '<div class="d-flex justify-content-center">' + icons.join('') + '</div>';
                        }, this)
                    });
                    break;
                case 'companyName':
                    columns.push({
                        "columnData": "companyName",
                        "data": "attributes.companyName",
                        "title": "Company",
                    });
                    break;
                case 'contactName':
                    columns.push({
                        "columnData": "contactName",
                        "data": "attributes.contactName",
                        "title": "Contact",
                    });
                    break;
                case 'contactTitle':
                    columns.push({
                        "columnData": "contactTitle",
                        "data": "attributes.contactTitle",
                        "title": "Title"
                    });
                    break;
                case 'address1':
                    columns.push({
                        "columnData": "address1",
                        "data": "attributes.address1",
                        "title": "Address 1"
                    });
                    break;
                case 'address2':
                    columns.push({
                        "columnData": "address2",
                        "data": "attributes.address2",
                        "title": "Address 2"
                    });
                    break;
                case 'city':
                    columns.push({
                        "columnData": "city",
                        "data": "attributes.city",
                        "title": "City"
                    });
                    break;
                case 'state':
                    columns.push({
                        "columnData": "state",
                        "data": "attributes.state",
                        "title": "State",
                    });
                    break;
                case 'zip':
                    columns.push({
                        "columnData": "zip",
                        "data": "attributes.zip",
                        "title": "Zip",
                    });
                    break;
                case 'country':
                    columns.push({
                        "columnData": "country",
                        "data": "attributes.country",
                        "title": "Country",
                    });
                    break;
                case 'phone':
                    columns.push({
                        "columnData": "phone",
                        "data": "attributes.phone",
                        "title": "Phone",
                        "width": "110px",
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('phone') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('phone')) + (_.size(row.get('phoneExtension')) === 0 ? '' : ' x' + row.get('phoneExtension')) : 'N/A'),
                                phoneWrapped = (row.get('phone') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('phone'), true) + (_.size(row.get('phoneExtension')) === 0 ? '' : ' x' + row.get('phoneExtension')) : 'N/A');

                            if (row.get('phone') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('phone') ? '' : 'text-muted') + '">' + phoneWrapped + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'cell':
                    columns.push({
                        "columnData": "cell",
                        "data": "attributes.cell",
                        "title": "Cell",
                        "width": "110px",
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('cell') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('cell')) : 'N/A'),
                                phoneWrapped = (row.get('cell') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('cell'), true) : 'N/A');

                            if (row.get('cell') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Cell #" data-phone="' + phoneFormatted + '"><i class="far fa-mobile-alt text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('cell') ? '' : 'text-muted') + '">' + phoneWrapped + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'fax':
                    columns.push({
                        "columnData": "fax",
                        "data": "attributes.fax",
                        "title": "Fax",
                        "width": "110px",
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('fax') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('fax')) : 'N/A'),
                                phoneWrapped = (row.get('fax') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('fax'), true) : 'N/A');

                            if (row.get('fax') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Fax #" data-phone="' + phoneFormatted + '"><i class="far fa-fax text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('fax') ? '' : 'text-muted') + '">' + phoneWrapped + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'email':
                    columns.push({
                        "columnData": "email",
                        "data": "attributes.email",
                        "title": "Email",
                        "render": function (data, type, row) {
                            let email = data;
                            if (_.size(email) === 0) {
                                return '';
                            }

                            let project = PJQ.app.session.project,
                                subject = project.get('projectName') + ' - ' + project.get('city') + ', ' + project.get('state'),
                                accessKey = row.get('accessKey'),
                                body;
                            if (accessKey != null && _.size(accessKey.trim()) > 0) {
                                let projectUrl = window.location.origin + '/?accessKey=' + accessKey + '#projects/' + project.id.toString() + '';
                                body = 'Click here to view the project: ' + projectUrl;
                            } else {
                                body = '';
                            }

                            let html = '<div style="max-width:' + (maxEmailWidth != null ? (maxEmailWidth.toString() + 'px;') : 'auto') + '" class="d-flex align-items-center wd-100">',
                                mailto = email + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body),
                                emailFormatted = '<a target="_blank" title="' + email + '" style="color: inherit;" href="mailto:' + mailto + '">' + email + '</a>';
                            html += '<button type="button" class="btn btn-transparent-dark btn-copy-email" title="Copy Email" data-email="' + row.get('email') + '"><i class="far fa-envelope text-dark"></i></button>';
                            html += '<div class="flex-fill of-hidden tof-ellipsis no-wrap' + (row.get('email') ? '' : 'text-muted') + '">' + emailFormatted + '</div></div>';
                            return html;
                        }
                    });
                    break;
                case 'unionStatus':
                    columns.push({
                        "columnData": 'unionStatus',
                        "title": 'Union Status',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isUnion'))
                                status.push('Union');
                            if (row.get('isNonUnion'))
                                status.push('Non-Union');
                            if (row.get('isPrevailingWage'))
                                status.push('Prevailing Wage');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'sector':
                    columns.push({
                        "columnData": 'sector',
                        "title": 'Labor Sector',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isPublicSector'))
                                status.push('Public');
                            if (row.get('isPrivateSector'))
                                status.push('Private');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'certifications':
                    columns.push({
                        "columnData": 'certifications',
                        "title": 'Certification',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isDBE'))
                                status.push('DBE');
                            if (row.get('isDVBE'))
                                status.push('DVBE');
                            if (row.get('isMBE'))
                                status.push('MBE');
                            if (row.get('isSBE'))
                                status.push('SBE');
                            if (row.get('isSDVBE'))
                                status.push('SDVBE');
                            if (row.get('isWBE'))
                                status.push('WBE');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'groupListDisplay':
                    columns.push({
                        "columnData": "groupListDisplay",
                        "data": "attributes.groupListDisplay",
                        "title": "Trades",
                        "render": function (data) {
                            let groupDisplayLimit = 0, groupArray = data ? data.split(',') : [];
                            if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_MAX_GROUP_DISPLAY)) {
                                groupDisplayLimit = parseInt(PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_MAX_GROUP_DISPLAY));
                            }

                            if (groupDisplayLimit > 0 && (_.size(groupArray) > groupDisplayLimit)) {
                                return _.rest(groupArray.reverse(), _.size(groupArray) - groupDisplayLimit).reverse().join(', ') + " <br>" +
                                    "<a href='javascript:void(0)' class='btn-show-groups' title='Click to show complete list of Trades'> " + (_.size(groupArray) - groupDisplayLimit) + " more item(s)</a>";
                            } else {
                                return data;
                            }
                        }
                    });
                    break;
                case 'distance':
                    columns.push({
                        "columnData": 'distance',
                        "data": {
                            "_": function (row) {
                                return row.get('distance') == null ? 0 : row.get('distance');
                            },
                            "display": function (row) {
                                if (row.get('distance') == null) {
                                    return '';
                                }
                                return row.get('distance').toFixed(2).toString() + ' mi.';
                            }
                        },
                        "title": 'Distance',
                    });
                    break;
                case 'grade':
                    columns.push({
                        "columnData": 'grade',
                        "title": 'Grade',
                        "width": "40px",
                        "render": function (data, type, row) {
                            let html = '<span class="mr-1">' + row.get('gradeAverage').toString() + '</span>';
                            html += (row.get('grade') !== 0) ? '<button type="button" class="btn btn-transparent-dark btn-grade-project-contact" title="Review Grade" data-contact-company-id="' + row.get('contactCompanyId') + '"><i class="fas fa-star text-gold"></i></button>' : '<button type="button" class="btn btn-transparent-dark btn-grade-project-contact" title="Grade" data-contact-company-id="' + row.get('contactCompanyId') + '"><i class="far fa-star text-muted"></i></button>';
                            return html;
                        }
                    });
                    break;
                case 'userType':
                    columns.push({
                        "columnData": 'userType',
                        "title": 'Contact Type',
                        "data": 'userType',
                        "render": function (data, type, row) {
                            let userType = _.filter(PJQ.app.session.userTypes.getByIsCompany(false), _.bind(function (userType) {
                                return row.get('userTypeId') === userType.get('userTypeId');
                            }, this))[0];

                            return userType != null ? userType.get('name') : 'N/A';
                        }
                    });
                    break;
                case 'commentsCompany':
                    columns.push({
                        "columnData": 'commentsCompany',
                        "title": 'Comments (Company)',
                        "render": function (data, type, row) {
                            let html = '<div style="min-width:150px;" class="d-flex align-items-center">';
                            html += '<div data-id="' + row.get('contactCompanyId') + '" class="flex-fill comment-company ' + (row.get('lastCompanyComment') ? '' : 'text-muted') + '">' + (row.get('lastCompanyComment') ? row.get('lastCompanyComment').comment : 'No Comments Added') + '</div>';
                            html += '<button type="button" class="btn btn-transparent-dark btn-add-comment-company" title="Add Comment"><i class="far fa-comment-plus text-dark"></i></button>';
                            html += '<button type="button" class="btn btn-transparent-dark btn-comment-contact-company" title="Comments" data-contact-company-id="' + row.get('contactCompanyId') + '"><i class="far fa-comments text-dark"></i></button>';
                            html += '</div>';
                            return html;
                        }
                    });
                    break;
                case 'commentsContact':
                    columns.push({
                        "columnData": 'commentsContact',
                        "title": 'Comments (Contact)',
                        "render": function (data, type, row) {
                            let html = '<div style="min-width:150px;" class="d-flex align-items-center">';
                            html += '<div data-id="' + row.get('contactId') + '" class="flex-fill comment-contact ' + (row.get('lastContactComment') ? '' : 'text-muted') + '">' + (row.get('lastContactComment') ? row.get('lastContactComment').comment : 'No Comments Added') + '</div>';
                            html += '<button type="button" class="btn btn-transparent-dark btn-add-comment-contact" title="Add Comment"><i class="far fa-comment-plus text-dark"></i></button>';
                            html += '<button type="button" class="btn btn-transparent-dark btn-comment-contact" title="Comments" data-contact-id="' + row.get('contactId') + '"><i class="far fa-comments text-dark"></i></button>';
                            html += '</div>';
                            return html;
                        }
                    });
                    break;
                case 'bidAmount':
                    columns.push({
                        "columnData": "bidAmount",
                        "data": {
                            "_": function (row) {
                                return row.get('bidAmount');
                            },
                            "display": function (row) {
                                if (canManage) {
                                    return '<input type="text" class="form-control contact-bid-amount input-dollars-full" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('bidAmount'), 2, false) + '" />';
                                }

                                return '<span>' + PJQ.helpers.formatHelpers.formatCurrency(row.get('bidAmount'), 2, true) + '</span>'
                            }
                        },
                        "title": "Bid Amount"
                    });
                    break;
                case 'status':
                    if (this.options.view === PJQ.constants.projectMessaging.views.MSGCONT_CONT) {
                        columns.push({
                            "columnData": 'status',
                            "title": 'Response',
                            "width": "100px",
                            "data": {
                                "_": function (row) {
                                    return row.get('status') ? row.get('status') : 'PENDING';
                                },
                                "display": function (row) {
                                    let html = '<select class="form-control contact-message-status" style="min-width:100px;">',
                                        statuses = [],
                                        isProjectResponse = PJQ.app.session.project.getProjectStatusList().indexOf(row.get('status')) != -1;

                                    if (row.collection.options.responseType === 'PROJECT')
                                        statuses = PJQ.app.session.project.getProjectStatusList();
                                    else if (row.collection.options.responseType === 'MESSAGE')
                                        statuses = PJQ.app.session.project.getMessageStatusList();
                                    else
                                        return _.size(row.get('status')) === 0 ? 'N/A' : row.get('status');

                                    statuses.unshift(['PENDING', true]);

                                    _.each(statuses, _.bind(function (status, index) {
                                        html += '<option value="' + status[0] + '"' + (status[0] === row.get('status') ? ' SELECTED' : '') + '>' + status[0] + '</option>';
                                    }, this));

                                    html += '</select>';

                                    if (row.collection.options.responseType === '')
                                        html = _.size(row.get('status')) === 0 ? 'N/A' : row.get('status');

                                    return html;
                                }
                            }
                        });
                    } else {
                        columns.push({
                            "columnData": 'status',
                            "title": 'Status',
                            "width": "120px",
                            "data": {
                                "_": function (row) {
                                    return row.get('status') ? row.get('status') : 'PENDING';
                                },
                                "display": function (row) {
                                    if (canManage) {
                                        let html = '<select class="form-control contact-project-status" style="min-width: 100px;">',
                                            statuses = PJQ.app.session.project.getProjectStatusList();
                                        statuses.unshift(['PENDING', true]);
                                        _.each(statuses, _.bind(function (status, index) {
                                            html += '<option value="' + status[0] + '"' + (status[0] === row.get('status') ? ' SELECTED' : '') + '>' + status[0] + '</option>';
                                        }, this));
                                        html += '</select>';
                                        return html;
                                    }

                                    let status = row.get('status');
                                    return '<span>' + (_.size(status) > 0 ? status.toUpperCase() : 'PENDING') + '</span>';
                                }
                            }
                        });
                    }
                    break;
                case 'accessKey':
                    columns.push({
                        "columnData": "accessKey",
                        "data": "attributes.accessKey",
                        "title": "Access Key",
                        "render": function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">';
                            html += '<div class="flex-fill ' + (row.get('accessKey') ? '' : 'text-muted') + '">' + (row.get('accessKey') ? row.get('accessKey') : '') + '</div>';
                            if (row.get('accessKey') !== '' && row.get('accessKey') !== ' ')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-access-key" title="Copy Access Key" data-access-key="' + row.get('accessKey') + '"><i class="far fa-key text-dark"></i></button>';
                            html += '</div>';
                            return html;
                        }
                    });
                    break;
                case 'broadcastStatus':
                    columns.push({
                        "columnData": 'broadcastStatus',
                        "data": "attributes.broadcastStatus",
                        "title": 'Broadcast Status',
                        "render": function (data, type, row) {
                            let broadcastStatus = _.size(row.get('broadcastStatus')) === 0 ? 'PENDING' : row.get('broadcastStatus');
                            return '<span title="' + (_.size(row.get('broadcastErrorMessage')) === 0 ? broadcastStatus : row.get('broadcastErrorMessage')) + '" >' + broadcastStatus + '</span>';
                        }
                    });
                    break;
                case 'responded':
                    columns.push({
                        "columnData": "responded",
                        "data": {
                            "_": function (row) {
                                return new Date(row.get('rsvpOn'));
                            },
                            "filter": "attributes.rsvpOn",
                            "display": function (row) {
                                return row.get('rsvpOn') ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('rsvpOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true) : 'N/A';
                            }
                        },
                        "title": "Responded"
                    });
                    break;
                case 'deliveredOn':
                    columns.push({
                        "columnData": "deliveredOn",
                        "data": {
                            "_": function (row) {
                                return new Date(row.get('deliveredOn'));
                            },
                            "filter": "attributes.deliveredOn",
                            "display": function (row) {
                                return row.get('deliveredOn') ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('deliveredOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true) : 'N/A';
                            }
                        },
                        "title": "Delivered"
                    });
                    break;
                case 'openedOn':
                    columns.push({
                        "columnData": "openedOn",
                        "data": {
                            "_": function (row) {
                                return new Date(row.get('openedOn'));
                            },
                            "filter": "attributes.openedOn",
                            "display": function (row) {
                                return row.get('openedOn') ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('openedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true) : 'N/A';
                            }
                        },
                        "title": "Opened"
                    });
                    break;
                case 'activityRank':
                    if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_ACTIVITY_RANK_STATUS_LIST)) {
                        columns.push({
                            "columnData": 'activityRank',
                            "data": 'attributes.activityRank',
                            "title": 'Activity'
                        });
                    }
                    break;

            }

            if (columnName.startsWith('companyCustomField_')) {
                let customFieldId = parseInt(columnName.substring(columnName.indexOf('_') + 1));

                _.each(PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
                    if (customField.id === customFieldId)
                        columns.push(this.getCustomFieldColumn(customField, true));
                }, this));
            }

            if (columnName.startsWith('contactCustomField_')) {
                let customFieldId = parseInt(columnName.substring(columnName.indexOf('_') + 1));

                _.each(PJQ.app.session.customFields.contact[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
                    if (customField.id === customFieldId)
                        columns.push(this.getCustomFieldColumn(customField, false));
                }, this));
            }

        }, this));

        return columns;
    },
    getChildTableType: function () {
        return PJQ.constants.projectMessaging.views.CONTGROUP;
    },
    getRowChildTable: function (childOpts) {
        childOpts.view = this.getChildTableType();
        childOpts.dom = 't';
        childOpts.parentDataTable = this;
        childOpts.paging = false;
        return new PJQ.views.projects.ProjectMessagingContactTradesDataTable(childOpts);
    },
    getRowChildData: function (row) {
        return new PJQ.collections.projectParticipants.ProjectParticipantsForView(null, {
            project: PJQ.app.session.project,
            view: PJQ.constants.projectMessaging.views.CONTGROUP,
            contactId: row.data().get('contactId')
        });
    },
    statusChanged: function (statuses, parentTR, parentView) {

        let self = this;
        if (parentTR) {
            this.statusChangedHelper(this.getRow(parentTR), statuses, parentTR, parentView);
        } else {
            this.dataTable.rows().every(function (rowIdx, tableLoop, rowLoop) {
                self.statusChangedHelper(this, statuses, parentTR, parentView);
            });
        }
        this.dataTable.draw();

        // if this is the child of the company view, update the parent as well
        if (this.options.parentDataTable != null) {
            this.options.parentDataTable.statusChanged(statuses, parentTR ? parentTR.parent().closest('tr').prev() : null, parentView);
        }

    },
    statusChangedHelper: function (row, statuses, parentTR, parentView) {
        switch (this.options.view) {
            case PJQ.constants.projectMessaging.views.COMP_CONT:
            case PJQ.constants.projectMessaging.views.CONT:
            case PJQ.constants.projectMessaging.views.RSPCONT_CONT:
                // these views cannot have a group status, so update the regular status column and redraw the row.
                row.data().set('status', statuses.projectStatus);
                row.invalidate();
                this.setRowStyle(row.node(), row.data().get('status'), row.data().get('isBlacklisted') || row.data().get('isCompanyBlacklisted'));


                // update the groups subgrid if it exists
                if (parentView !== PJQ.constants.projectMessaging.views.CONTGROUP) {
                    _.each(this.options.childDataTables, _.bind(function (childDT) {
                        if (typeof childDT.statusChanged === 'function') {
                            childDT.statusChanged(statuses, null, this.options.view);
                        }
                    }, this));
                }
                break;
            case PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT:
            case PJQ.constants.projectMessaging.views.GROUPCONT_CONT:
                // these views must have a group status, so update the group status column and redraw the row.
                row.data().set('status', statuses.groupStatus);
                row.invalidate();
                this.setRowStyle(row.node(), row.data().get('status'), row.data().get('isBlacklisted') || row.data().get('isCompanyBlacklisted'));

                // update the groups subgrid if it exists
                _.each(this.options.childDataTables, _.bind(function (childDT) {
                    if (row.data().get('contactId') !== childDT.options.parentId)
                        return;

                    if (typeof childDT.statusChanged === 'function') {
                        childDT.statusChanged(statuses, null, this.options.view);
                    }
                }, this));
                break;
        }
    },
    onMessageStatusChanged: function (e) {
        let $target = $(e.currentTarget),
            status = $target.val().toUpperCase(),
            row = this.getRow($target.closest('tr')),
            data = row.data();

        data.updateStatus(status, _.bind(function () {
            this.setRowStyle(row.node(), row.data().get('status'), row.data().get('isBlacklisted') || row.data().get('isCompanyBlacklisted'));
            PJQ.notifications.notify.successNotify({
                message: 'Status updated'
            });
        }, this));
        // no parents or children to update in this case as it is a Message status.
    },
    bidAmountExited: function(e) {
        let bidAmount = PJQ.helpers.inputHelpers.getMoneyInputValue($(e.currentTarget).parent());
        $(e.currentTarget).val(PJQ.helpers.formatHelpers.formatCurrency(bidAmount, 2, false));
    },
    bidAmountChanged: function (e) {
        if (e.ctrlKey && e.key != 'v') {
            e.stopPropagation();
            return false;
        }

        let tr = $(e.currentTarget).closest('tr'),
            parentTR = $(e.currentTarget).closest('tr').parent().closest('tr').prev(),
            row = this.getRow(tr),
            bidAmount = PJQ.helpers.inputHelpers.getMoneyInputValue($(e.currentTarget).parent()),
            callback = function (context) {
                if (context.options.parentDataTable !== undefined && (context.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.COMP || context.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP)) {
                    let bidAmountTotal = 0;
                    _.each(context.dataTable.data(), _.bind(function (item) {
                        if (item.get('contactCompanyId') === row.data().get('contactCompanyId'))
                            bidAmountTotal += item.get('bidAmount');
                    }, context));

                    let rowParent = context.options.parentDataTable.getRow(parentTR);
                    rowParent.data().set('bidAmount', bidAmountTotal);
                    //rowParent.invalidate().draw();
                    $(parentTR).find('.bid-amount-total').text(PJQ.helpers.formatHelpers.formatCurrency(bidAmountTotal, 2, true));
                }
            };

        row.data().set('bidAmount', bidAmount);
        row.data().set('contactCompanyId', row.data().get('contactCompanyId'));
        row.data().set('projectId', PJQ.app.session.project.id);
        row.data().set('isUpdateBidAmount', true);
        row.data().queueSave({bidAmount: bidAmount}, {
            //patch: true,
            success: _.bind(function () {
                callback(this);
            }, this)
        }, 800);

    },
    contactSelectChanged: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            parentTR = $(e.currentTarget).closest('tr').parent().closest('tr').prev(),
            row = this.getRow(tr);

        if ($(e.currentTarget).prop('checked')) {
            this.options.projectMessagingView.addSelectedContacts([row.data().get('contactId')]);

            if (this.options.parentDataTable && (this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP || this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCONT)) {
                let groupId = parseInt(row.data().collection.options.groupIdList);
                this.options.projectMessagingView.addSelectedContactGroups([{
                    contactId: row.data().get('contactId'),
                    groupId: groupId
                }]);
            }
        } else {
            this.options.projectMessagingView.removeSelectedContacts([row.data().get('contactId')]);
            if (this.options.parentDataTable && (this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP || this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCONT)) {
                let groupId = parseInt(row.data().collection.options.groupIdList);
                this.options.projectMessagingView.removeSelectedContactGroups([{
                    contactId: row.data().get('contactId'),
                    groupId: groupId
                }]);
            }
        }

        if (this.options.parentDataTable === undefined)
            return;

        let totalContacts = 0, selectedContacts = 0;
        _.each(this.dataTable.data(), _.bind(function (item) {
            if (item.get('contactCompanyId') === row.data().get('contactCompanyId')) {
                totalContacts++;
                if (this.options.projectMessagingView.isContactSelected(item.get('contactId')))
                    selectedContacts++;
            }
        }, this));

        if (selectedContacts === 0) {
            parentTR.find('input.select-company').prop('checked', false).prop('indeterminate', false).removeClass('indeterminate');
        } else if (selectedContacts === totalContacts) {
            parentTR.find('input.select-company').prop('checked', true).prop('indeterminate', false).removeClass('indeterminate');
        } else {
            // indeterminate
            parentTR.find('input.select-company').prop('checked', false).prop('indeterminate', true).addClass('indeterminate');
        }
    },
    contactSelectAllChanged: function (e) {
        let projectStatusList = PJQ.app.session.project.getProjectStatusList(),
            isChecked = $(e.currentTarget).prop('checked'),
            isEnableDeclined = this.options.projectMessagingView.isEnableDeclined(), selectedContacts = [],
            groupId = null, isGroupsView = false, selectedContactGroups = [];

        if (this.options.parentDataTable && (this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP || this.options.parentDataTable.options.view === PJQ.constants.projectMessaging.views.GROUPCONT)) {
            isGroupsView = true;
            groupId = parseInt(this.options.data[0].collection.options.groupIdList);
        }

        _.each(this.dataTable.data(), _.bind(function (row) {
            if (isChecked) {
                if ((isEnableDeclined || projectStatusList[1].toString().split(',')[0].toLowerCase() !== row.attributes.status.toString().toLowerCase()) &&
                    !row.attributes.isBlacklisted && !row.attributes.isCompanyBlacklisted)
                    selectedContacts.push(row.attributes.contactId);
            } else {
                selectedContacts.push(row.attributes.contactId);
            }
        }, this));

        if (isGroupsView) {
            _.each(selectedContacts, _.bind(function (selectedContact) {
                selectedContactGroups.push({contactId: selectedContact, groupId: groupId});
            }, this));
        }

        if (isChecked) {
            this.options.projectMessagingView.addSelectedContacts(selectedContacts);
            if (isGroupsView)
                this.options.projectMessagingView.addSelectedContactGroups(selectedContactGroups);
        } else {
            this.options.projectMessagingView.removeSelectedContacts(selectedContacts);
            if (isGroupsView)
                this.options.projectMessagingView.removeSelectedContactGroups(selectedContactGroups);
        }

        this.refresh(false);
    },
    createdRow: function (row, data, dataIndex) {
        let status = data.attributes.status;
        if (this.options.view === PJQ.constants.projectMessaging.views.MSGCONT_CONT &&
            data.collection.options.responseType !== 'PROJECT'
            && data.collection.options.responseType !== 'MESSAGE')
            status = '';

        this.setRowStyle(row, status, data.attributes.isBlacklisted || data.attributes.isCompanyBlacklisted)
    },
    setRowStyle: function (row, status, isBlacklisted) {
        let statusColor = _.find(this.options.projectMessagingView.options.settings.attributes.statusColors, function (statusColor) {
            return statusColor.status === status
        }), rowCss = '';

        if (statusColor) {
            let foregroundColor = PJQ.helpers.colorHelpers.idealLinkColorForBackground(statusColor.backgroundColor);
            rowCss = 'background-color:' + statusColor.backgroundColor + ' !important;' + 'color:' + foregroundColor + ' !important;';
        }

        if (isBlacklisted)
            rowCss += ' text-decoration: line-through !important;';

        $(row).css({cssText: rowCss});

    },
    copyAccessKey: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('accessKey'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Access Key copied to clipboard.'
        });
    },
    copyPhone: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('phone').replace(/ /g,''),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Number copied to clipboard.'
        });
    },
    copyEmail: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('email'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Email copied to clipboard.'
        });
    },
    showRowGroups: function (e) {
        let target = $(e.currentTarget),
            row = this.getRow(target.closest('tr')),
            data = row.data(),
            groups = data.get('groupListDisplay').split(','),
            groupDisplayLimit = parseInt(PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_MAX_GROUP_DISPLAY));
        target[0].outerHTML = ' ' + _.rest(groups, groupDisplayLimit).join(', ')
    }
});

PJQ.views.projects.ProjectMessagingContactTradesDataTable = PJQ.views.projects.ProjectMessagingDataTable.extend({
    events: {
        'change select.project-contact-group-status': 'onStatusChanged',
        'keyup .contact-group-bid-amount': 'bidAmountChanged',
        'blur .contact-group-bid-amount': 'bidAmountExited'
    },
    afterDataTableRenderChild: function () {
        PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.contact-group-bid-amount'), 2);
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [];
        columns.push({
            "columnData": "groupName",
            "data": "attributes.groupName",
            "title": "Trade",
            "orderable": false
        });

        columns.push({
            "columnData": 'groupStatus',
            "width": "150px",
            "title": 'Trade Status',
            "render": function (data, type, row) {
                let html = '<select class="form-control project-contact-group-status">',
                    statuses = PJQ.app.session.project.getProjectStatusList();
                statuses.unshift(['PENDING', true]);
                _.each(statuses, _.bind(function (status, index) {
                    html += '<option value="' + status[0] + '"' + (status[0] === row.get('groupStatus') ? ' SELECTED' : '') + '>' + status[0] + '</option>';

                }, this));
                html += '</select>';
                return html;
            },
            "orderable": false
        });

        if (this.options.projectMessagingView && this.options.projectMessagingView.options.canViewBidAmount) {
            columns.push({
                "columnData": "bidAmount",
                "data": "attributes.bidAmount",
                "width": "100px",
                "title": "Bid Amount",
                "render": function (data, type, row) {
                    return '<input type="text" class="form-control contact-group-bid-amount input-dollars-full" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('bidAmount'), 2, false) + '" />';
                }
            });
        }


        return columns;
    },
    statusChanged: function (statuses, parentTR, parentView) {
        if (!(parentView === PJQ.constants.projectMessaging.views.CONT || parentView === PJQ.constants.projectMessaging.views.COMP || parentView === PJQ.constants.projectMessaging.views.COMP_CONT || parentView === PJQ.constants.projectMessaging.views.GROUPCONT_CONT || parentView === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT || parentView === PJQ.constants.projectMessaging.views.RSPCONT_CONT || parentView === PJQ.constants.projectMessaging.views.BIDPKGS_CONT))
            return;

        let groupId = 0;
        if (parentView === PJQ.constants.projectMessaging.views.GROUPCONT_CONT || parentView === PJQ.constants.projectMessaging.views.GROUPCOMP_COMP_CONT)
            groupId = parseInt(this.options.parentDataTable.dataTable.rows(0).row().data().collection.options.groupIdList);

        // if we are being called, we must update ALL rows(trades) in our datatable and then redraw the whole thing.
        _.each(this.dataTable.data(), _.bind(function (item) {
            if (groupId === 0 || groupId === item.get('groupId'))
                item.set('groupStatus', statuses.groupStatus);
        }, this));

        this.dataTable.rows().invalidate().draw();
    },
    bidAmountExited: function(e) {
        let bidAmount = PJQ.helpers.inputHelpers.getMoneyInputValue($(e.currentTarget).parent());
        $(e.currentTarget).val(PJQ.helpers.formatHelpers.formatCurrency(bidAmount, 2, false));
    },
    bidAmountChanged: function (e) {

        if (e.ctrlKey && e.key != 'v') {
            e.stopPropagation();
            return false;
        }

        let tr = $(e.currentTarget).closest('tr'),
            parentTR = tr.parent().closest('tr').prev(),
            row = this.getRow(tr),
            bidAmount = PJQ.helpers.inputHelpers.getMoneyInputValue($(e.currentTarget).parent());

        /*
		row.data().set('contactCompanyId', row.data().get('contactCompanyId'));
		row.data().set('projectId', PJQ.app.session.project.id);
		*/

        row.data().set('bidAmount', bidAmount);
        row.data().queueSave({bidAmount: bidAmount}, {
            patch: true,
            success: _.bind(function (response) {
                //row.invalidate().draw(); -- 2023-07-31 blue: this causes the field to lose focus

                // iterate through all rows in this table to get the total for this contact
                let contactBidTotal = 0;
                _.each(this.dataTable.data(), _.bind(function (item) {
                    contactBidTotal += item.get('bidAmount');
                }, this));

                // update the contact's Bid Amount field
                let parentRow = this.options.parentDataTable.getRow(parentTR);
                parentRow.data().set('bidAmount', contactBidTotal);
                //parentRow.invalidate().draw(); -- 2023-07-31 blue: this causes the field to lose focus
                $(parentTR).find('.contact-bid-amount').val(PJQ.helpers.formatHelpers.formatCurrency(contactBidTotal, 2, false));

                // if main view is Company, iterate through all contacts to get their bid amounts
                if (this.options.projectMessagingView.currentView === PJQ.constants.projectMessaging.views.COMP || this.options.projectMessagingView.currentView === PJQ.constants.projectMessaging.views.GROUPCOMP) {

                    let companyBidTotal = 0, parentParentTR = parentTR.parent().closest('tr').prev();
                    _.each(this.options.parentDataTable.dataTable.data(), _.bind(function (item) {
                        companyBidTotal += item.get('bidAmount');
                    }, this));

                    // update parent company row's Bid Amount Total
                    let parentParentRow = this.options.parentDataTable.options.parentDataTable.getRow(parentParentTR);
                    parentParentRow.data().set('bidAmount', companyBidTotal);
                    //parentParentRow.invalidate().draw(); -- 2023-07-31 blue: this causes the field to lose focus
                    $(parentParentTR).find('.bid-amount-total').text(PJQ.helpers.formatHelpers.formatCurrency(contactBidTotal, 2, true));

                }
            }, this)
        }, 800);

    }
});
